{
  "nav": {
    "dashboard": "Tableau de bord",
    "chats": "Chats",
    "archive": "Archive",
    "settings": "Réglages",
    "studioData": "Données Studio",
    "propertyData": "informations sur le bien",
    "expandMenu": "Voir",
    "collapseMenu": "Réduire le menu",
    "goToDashboard": "Accéder au tableau de bord",
    "logOut": "Déconnexion"
  },
  "layout": {
    "lastUpdatedJustNow": "Dernière mise à jour : à l'instant",
    "lastUpdatedOneMin": "Dernière mise à jour il y a 1 min",
    "lastUpdatedMins": "Dernière mise à jour il y a {{count}} min",
    "wsOffline": "Connexion perdue. Actualisez ou attendez la reconnexion.",
    "refresh": "Renouvellement",
    "refreshing": "En cours d'actualisation..."
  },
  "settings": {
    "title": "Réglages",
    "subtitle": "Gérez le compte, l'équipe et les canaux.",
    "tabAccount": "Client en Compte",
    "tabTeam": "Gestion d'équipe",
    "tabChannels": "Canaux",
    "tabAi": "comportement",
    "logOut": "Se déconnecter",
    "noPermissionToast": "Vous n’êtes pas autorisé à consulter cette page.",
    "connections": {
      "email": {
        "channelLabel": "E-mail",
        "appliesToAllStudios": "Tous les studios",
        "addressLabel": "Boîte mail",
        "defaultStudioLabel": "Studio par défaut pour les nouveaux fils",
        "statusConnected": "Connecté",
        "statusReconnectRequired": "Reconnexion requise",
        "statusDisconnected": "Non connecté",
        "statusError": "Erreur",
        "statusSkipped": "Ignoré",
        "connect": "Connecter",
        "reconnect": "Reconnecter",
        "disconnect": "Déconnecter",
        "reconnectBanner": "Votre connexion e-mail a expiré. Reconnectez pour envoyer et recevoir des messages.",
        "reconnectBannerCta": "Reconnecter l’e-mail",
        "disconnectTitle": "Déconnecter l’e-mail ?",
        "disconnectBody": "Cela révoque l’accès à votre boîte partagée. Les fils passés restent lisibles ; l’envoi est désactivé jusqu’à une nouvelle connexion.",
        "toastDisconnected": "E-mail déconnecté.",
        "toastDisconnectFailed": "Impossible de déconnecter l’e-mail."
      }
    }
  },
  "account": {
    "displayLanguageTitle": "Afficher la langue.",
    "displayLanguageHint": "L'anglais, l'allemand, le français, l'italien et l'espagnol s'appliquent à toute l'application, y compris la connexion, l'inscription et l'intégration.",
    "displayLanguageLabel": "Votre langue",
    "languageUpdated": "Langue d'affichage mise à jour.",
    "emailTitle": "Adresse e-mail",
    "newEmail": "Nouvel e-mail",
    "currentPassword": "Mot de passe actuel",
    "emailPasswordPlaceholder": "Obligatoire pour modifier l'adresse e-mail",
    "save": "Sauvegarder",
    "cancel": "Annuler",
    "changeEmail": "Modifier l’e-mail",
    "passwordTitle": "Mot de passe",
    "passwordSharedWarning": "Ce mot de passe est partagé entre votre application studio OktoGo et le portail Management. Le modifier ici met à jour votre connexion sur les deux.",
    "passwordConfirmTitle": "Modifier le mot de passe sur les deux plateformes ?",
    "passwordConfirmBody": "Cela modifie votre connexion à la fois pour l’application studio OktoGo (app.oktogo.ai) et pour Management, avec la même adresse e-mail.",
    "passwordConfirmCancel": "Annuler",
    "passwordConfirmSubmit": "Oui, modifier le mot de passe",
    "newPassword": "Nouveau mot de passe",
    "confirmNewPassword": "Confirmez le nouveau mot de passe",
    "updatePassword": "Mettre à jour le mot de passe",
    "changePassword": "Modifier le mot de passe",
    "verticalLabel": "Vertical",
    "notificationTitle": "Préférences de notification",
    "escalationAlerts": "Alertes d'escalade",
    "escalationAlertsDesc": "Notification push lorsqu'un chat est escaladé pour revue ou prise en charge humaine (toujours activée). L'e-mail d'escalade (motif + extrait) est distinct des e-mails d'expiration de session WhatsApp. Une option Compte pour couper uniquement l'e-mail d'escalade arrive bientôt ; le push reste activé.",
    "weeklySummary": "Résumé hebdomadaire",
    "weeklySummaryDesc": "Recevoir un rapport de performance hebdomadaire",
    "connectionWarnings": "Avertissements de connexion",
    "connectionWarningsDesc": "Alerte lorsqu'une connexion à la plateforme est perdue",
    "notificationsSaved": "Préférences de notification enregistrées.",
    "verticalFitness": "Studio de conditionnement physique",
    "verticalStr": "Location à court terme",
    "toastCurrentPasswordForEmail": "Veuillez saisir votre mot de passe actuel pour modifier votre adresse e-mail.",
    "toastVerificationEmailSent": "E-mail de vérification envoyé à une nouvelle adresse.",
    "toastEmailUpdateFailed": "Impossible de mettre à jour l'email de l'utilisateur.",
    "toastPasswordMismatch": "Les mots de passe ne correspondent pas.",
    "toastPasswordUpdated": "Mise à jour du mot de passe réussie.",
    "toastPasswordUpdateFailed": "Impossible de mettre à jour le mot de passe",
    "toastVerticalUpdated": "Produit vertical mis à jour.",
    "toastVerticalUpdateFailed": "Échec de la mise à jour verticale.",
    "toastPreferencesSaveFailed": "Échec de l’enregistrement. ",
    "studioNameTitleStudio": "Nom du studio",
    "studioNameTitleProperty": "Nom de la propriété",
    "studioNameHint": "C’est ainsi que votre lieu apparaît dans l’app, les notifications et les messages visibles par les clients.",
    "studioNameContextHint": "Sélectionnez un studio pour modifier son nom.",
    "studioNameValidation": "Le nom doit comporter entre 2 et 60 caractères.",
    "toastStudioNameUpdated": "Nom du studio mis à jour.",
    "toastPropertyNameUpdated": "Nom de la propriété mis à jour.",
    "toastStudioNameUpdateFailed": "Impossible de mettre à jour le nom."
  },
  "auth": {
    "languageSwitcherAria": "Langue d'affichage",
    "placeholderEmailExample": "vous@studio.com",
    "placeholderPassword": "••••••••",
    "placeholderPasswordCreate": "Définissez votre mot de passe",
    "placeholderPasswordConfirm": "Confirmez votre mot de passe",
    "placeholderStudioName": "Nom de votre studio",
    "onboardingSelectPlatform": "Sélectionnez votre plateforme",
    "onboarding2faSecret": "Saisissez votre secret 2FA ou code de secours",
    "login": {
      "subtitle": "Connectez-vous à votre studio",
      "lockout": "Trop de tentatives échouées. Réessayez dans {{minutes}} minutes.",
      "emailLabel": "Adresse e-mail",
      "passwordLabel": "Mot de passe",
      "passwordPlaceholder": "Entrez votre mot de passe",
      "rememberMe": "Se souvenir de moi",
      "rememberMeHelpOn": "Restez connecté sur cet appareil après la fermeture du navigateur.",
      "rememberMeHelpOff": "Vous serez déconnecté à la fermeture du navigateur.",
      "logIn": "Se connecter",
      "forgotPassword": "Mot de passe oublié ?",
      "orDivider": "ou",
      "continueWithGoogle": "Continuer avec Google",
      "noAccount": "Pas encore de compte ?",
      "createAccount": "Créer un compte →",
      "sessionExpiredToast": "Votre session a expiré. Veuillez vous reconnecter.",
      "pilotInviteHandoff": "Votre invitation pilote est acceptée. Connectez-vous avec le mot de passe que vous venez de créer.",
      "errorIncorrectCredentials": "E-mail ou mot de passe incorrect.",
      "errorEmailNotVerified": "L'adresse e-mail n'est pas vérifiée.",
      "resendVerificationAction": "Renvoyer l'e-mail de vérification",
      "resendVerificationToast": "E-mail de vérification envoyé. Vérifiez votre boîte de réception.",
      "resendVerificationRateLimited": "Trop de tentatives. Attendez 15 minutes avant de demander un nouvel e-mail.",
      "goToVerificationPage": "Aller à la page de vérification →",
      "errorNetwork": "Impossible d'atteindre le serveur. Démarrez l'API (ex. npm run dev ou dev:server) et réessayez.",
      "errorGooglePopupBlocked": "Une fenêtre contextuelle a été bloquée. Autorisez les pop-ups pour ce site et réessayez.",
      "errorGoogleSignIn": "La connexion Google a échoué. Réessayez ou utilisez l'e-mail et le mot de passe."
    },
    "register": {
      "subtitle": "Créez votre compte",
      "studioNameLabel": "Nom du studio",
      "emailLabel": "Adresse e-mail",
      "passwordLabel": "Mot de passe",
      "createAccount": "Créer un compte",
      "orDivider": "ou",
      "continueWithGoogle": "Continuer avec Google",
      "hasAccount": "Vous avez déjà un compte ?",
      "logIn": "Se connecter →",
      "validationStudioName": "Le nom du studio doit contenir au moins 2 caractères.",
      "validationEmail": "Saisissez une adresse e-mail valide.",
      "validationPassword": "Le mot de passe doit contenir au moins 8 caractères, 1 lettre et 1 chiffre.",
      "registrationFailed": "L'inscription a échoué. Veuillez réessayer.",
      "duplicateEmailLead": "Un compte existe déjà avec cet e-mail.",
      "duplicateEmailLink": "Se connecter →"
    },
    "forgot": {
      "subtitle": "Réinitialiser votre mot de passe",
      "emailLabel": "Adresse e-mail",
      "sentLead": "Consultez votre boîte de réception. Nous avons envoyé un lien de réinitialisation à votre e-mail.",
      "backToLogin": "← Retour à la connexion",
      "testResetLink": "(Test : aller à la page de réinitialisation)",
      "sendResetLink": "Envoyer le lien de réinitialisation",
      "errorGeneric": "Une erreur s'est produite. Veuillez réessayer.",
      "networkError": "Erreur réseau. Veuillez réessayer."
    },
    "reset": {
      "invalidLink": "Ce lien de réinitialisation est invalide ou a expiré.",
      "requestNewLink": "Demander un nouveau lien →",
      "tokenUsed": "Ce lien de réinitialisation a déjà été utilisé.",
      "requestNewOne": "Demander un nouveau lien →",
      "successBody": "Mot de passe mis à jour. Veuillez vous connecter.",
      "goToLogin": "Aller à la connexion →",
      "subtitle": "Définir un nouveau mot de passe",
      "newPasswordLabel": "Nouveau mot de passe",
      "confirmPasswordLabel": "Confirmer le mot de passe",
      "resetButton": "Réinitialiser le mot de passe",
      "testSimulateUsed": "(Test : simuler un jeton déjà utilisé)",
      "errorPasswordRules": "Le mot de passe doit contenir au moins 8 caractères, 1 lettre et 1 chiffre.",
      "errorPasswordMismatch": "Les mots de passe ne correspondent pas.",
      "errorTokenExpired": "Ce lien a expiré. Demandez-en un nouveau.",
      "networkError": "Erreur réseau. Veuillez réessayer.",
      "errorGeneric": "Une erreur s'est produite."
    },
    "invite": {
      "invalidToken": "Ce lien d'invitation est invalide.",
      "goToLogin": "Aller à la connexion →",
      "subtitle": "Accepter l'invitation d'équipe",
      "invalidUsed": "Cette invitation est invalide ou déjà utilisée.",
      "expired": "Cette invitation a expiré.",
      "expiredHint": "Demandez à l'administrateur du studio de renvoyer votre invitation.",
      "successRedirect": "Invitation acceptée. Redirection vers le tableau de bord…",
      "createPasswordLabel": "Créer un mot de passe",
      "termsPrivacy": "J'accepte les Conditions d'utilisation et la Politique de confidentialité.",
      "acceptButton": "Accepter l'invitation",
      "validationPassword": "Le mot de passe doit contenir au moins 8 caractères, 1 lettre et 1 chiffre.",
      "validationTerms": "Vous devez accepter les conditions pour continuer.",
      "errorAcceptFailed": "Impossible d'accepter l'invitation.",
      "errorNoSession": "Invitation acceptée mais aucune session de connexion créée.",
      "networkError": "Erreur réseau. Veuillez réessayer."
    },
    "civ": {
      "documentTitle": "Confirmez votre e-mail — OktoGo",
      "headerSubtitle": "Confirmer votre e-mail permet au studio de poursuivre votre réservation.",
      "consent": {
        "headline": "Confirmez votre identité pour {{ studioName }}",
        "body": "Cela confirme que cette adresse e-mail est la vôtre et permet à {{ studioName }} (propulsé par OktoGo.ai) d'effectuer la réservation que vous avez demandée sur {{ channelLabel }}.",
        "checkboxEmail": "Je confirme que cette adresse e-mail m'appartient.",
        "checkboxData": "J'accepte qu'OktoGo.ai stocke et traite mes données personnelles pour traiter cette demande, comme indiqué dans la <a>politique de confidentialité</a>.",
        "privacyPolicyAriaLabel": "Politique de confidentialité d'OktoGo.ai (s'ouvre dans un nouvel onglet)",
        "confirmButton": "Confirmer et continuer",
        "confirmButtonSubmitting": "Confirmation en cours…",
        "declineLink": "Ce n'était pas moi — refuser",
        "errorGeneric": "Une erreur s'est produite. Veuillez réessayer ou contacter le support.",
        "errorRateLimited": "Trop de tentatives. Veuillez patienter un instant et réessayer.",
        "errorVersionMismatch": "Cette page a été mise à jour. Veuillez l'actualiser et réessayer."
      },
      "success": {
        "headline": "Vous êtes vérifié.",
        "body": "Vous pouvez maintenant retourner sur votre conversation {{ channelLabel }} avec {{ studioName }} pour continuer. Nous reprenons exactement là où vous en étiez.",
        "closeHint": "Vous pouvez fermer cet onglet en toute sécurité."
      },
      "error": {
        "expiredHeadline": "Ce lien a expiré",
        "expiredBody": "Pour votre sécurité, le lien n'est valable que peu de temps. Répondez à votre conversation et nous vous en enverrons un nouveau.",
        "invalidHeadline": "Ce lien n'est pas valide",
        "invalidBody": "Impossible de reconnaître ce lien. Répondez à votre conversation pour recommencer.",
        "usedHeadline": "Déjà confirmé",
        "usedBody": "Cette adresse e-mail a déjà été confirmée. Vous pouvez retourner sur votre conversation pour continuer.",
        "networkHeadline": "Problème de connexion",
        "networkBody": "Impossible de contacter OktoGo. Vérifiez votre connexion Internet et réessayez.",
        "networkRetryButton": "Réessayer"
      },
      "declined": {
        "headline": "C'est noté — nous ne continuons pas.",
        "body": "Nous avons enregistré votre refus. S'il s'agit d'une erreur, contactez notre support et nous vous aiderons."
      },
      "terminal": {
        "contactSupport": "Contacter le support",
        "contactSupportAriaLabel": "Envoyer un e-mail au support OktoGo"
      }
    },
    "verify": {
      "title": "Vérifiez votre boîte de réception",
      "bodyGeneric": "Nous avons envoyé un lien de vérification à votre adresse e-mail. Cliquez sur le lien pour vérifier votre compte.",
      "bodyWithEmail": "Nous avons envoyé un e-mail de vérification à {{email}}. Cliquez sur le lien pour vérifier votre compte.",
      "linkExpiredTitle": "Votre lien de vérification a expiré.",
      "resendLink": "Renvoyer l'e-mail de vérification",
      "rateLimited": "Trop de tentatives. Attendez 15 minutes avant de demander un nouvel e-mail.",
      "resendButton": "Renvoyer l'e-mail de vérification",
      "resendButtonDone": "E-mail de vérification renvoyé ✓",
      "footerHint": "Vous ne l'avez pas reçu ? Vérifiez les courriers indésirables ou demandez un nouveau lien.",
      "testExpired": "(Test : simuler un jeton expiré)"
    },
    "verifyToken": {
      "loadingTitle": "Vérification de votre e-mail",
      "loadingBody": "Veuillez patienter pendant la confirmation de votre compte.",
      "successTitle": "E-mail vérifié",
      "successBody": "Votre compte est vérifié. Vous pouvez vous connecter.",
      "invalidTitle": "Lien de vérification invalide",
      "invalidBody": "Ce lien n’est pas valide. Demandez un nouvel e-mail de vérification depuis la page de connexion.",
      "expiredTitle": "Lien de vérification expiré",
      "expiredBody": "Ce lien a expiré. Demandez un nouvel e-mail de vérification depuis la page de connexion.",
      "errorTitle": "Échec de la vérification",
      "errorBody": "Nous n’avons pas pu vérifier votre e-mail. Réessayez ou demandez un nouveau lien.",
      "goToLogin": "Aller à la connexion"
    },
    "verifyEmailChange": {
      "loadingTitle": "Vérification de votre nouvel e-mail",
      "loadingBody": "Veuillez patienter pendant que nous confirmons votre changement d'e-mail.",
      "successTitle": "E-mail mis à jour avec succès",
      "successBody": "Votre adresse e-mail a été mise à jour.",
      "successBodyWithEmail": "Votre nouvel e-mail de connexion est {{email}}.",
      "invalidTitle": "Lien de changement d'e-mail invalide",
      "invalidBody": "Ce lien de changement d'e-mail est invalide ou a déjà été utilisé.",
      "expiredTitle": "Lien de changement d'e-mail expiré",
      "expiredBody": "Ce lien de changement d'e-mail a expiré. Relancez la modification depuis les paramètres.",
      "errorTitle": "Impossible de vérifier le changement d'e-mail",
      "errorBody": "Une erreur est survenue lors de la vérification de votre changement d'e-mail. Veuillez réessayer plus tard.",
      "goToLogin": "Aller à la connexion →"
    }
  },
  "common": {
    "search": "Rechercher...",
    "filter": "Filtre",
    "sort": "Trier",
    "apply": "Appliquer",
    "applyWithCount": "Postuler ({{count}})",
    "reset": "Réinitialiser",
    "clearAll": "Effacer tout",
    "cancel": "Annuler",
    "close": "Fermer",
    "loading": "Chargement....",
    "nameAZ": "De A-Z",
    "nameZA": "De Z-A",
    "moreFilters": "+{{count}} plus",
    "moreFiltersAria": "{{count}} filtres plus actifs — liste ouverte",
    "additionalFilters": "Filtres additionnels",
    "removeFilterAria": "Supprimer le filtre {{label}}",
    "loadingRoute": "Chargement de la page…",
    "loadingContent": "Chargement du contenu…",
    "loadingTable": "Chargement du tableau…"
  },
  "dashboard": {
    "todaysStats": "Statistiques d'aujourd'hui",
    "needsAttention": "Ceci nécessite votre attention&#x0D;",
    "seeAllChats": "Tous les chats",
    "badgeEscalated": "Réaffecté",
    "badgeDraftReady": "✏ BROUILLON PRÊT",
    "allClear": "Tout est clair ! Aucune conversation active pour le moment.",
    "weeklySummary": "Résumé hebdomadaire",
    "conversationsByIntent": "Conversations par intention",
    "autoVsManual": "Manipulation automatique vs manuelle",
    "legendAiHandled": "AI manipulée",
    "legendManual": "Manuel",
    "relativeJustNow": "À l'instant",
    "relativeMinsAgo": "Il y a {{count}} min",
    "relativeOneHourAgo": "il y a 1h",
    "relativeHoursAgo": "Il y a {{count}}h",
    "relativeOneDayAgo": "Il y a 1 jour",
    "relativeDaysAgo": "Il y a {{count}}d",
    "intentApi": {
      "booking": "Réservation",
      "rebooking": "Réserver de nouveau",
      "cancellation": "Annuler",
      "info": "Information",
      "schedule": "Calendrier",
      "account": "Client en Compte",
      "other": "D’autres"
    },
    "badgeSessionExpiring": "⏱ SESSION",
    "sessionExpiringTileWindow": "La fenêtre de messages libres se ferme {{time}}",
    "sessionBannerTitle": "Les réponses WhatsApp peuvent bientôt être limitées",
    "sessionBannerBody": "Au moins une conversation escaladée approche la fin de la fenêtre de messages libres. Ouvrez Chats pour répondre tant que c’est possible.",
    "sessionBannerDismiss": "Masquer",
    "sessionBannerOpenChats": "Ouvrir les chats filtrés",
    "relativeUntilShort": "{{time}} restantes"
  },
  "chats": {
    "loadingChats": "Chargement des chats…",
    "noConversations": "Aucune conversation trouvée",
    "noConversationsMatchFilters": "Aucune conversation ne correspond à votre recherche ou à vos filtres.",
    "listLoadFailed": "Impossible de charger les conversations. Veuillez réessayer.",
    "studioContextRequired": "Le contexte studio n'est pas correctement défini. Passez à un studio précis ou réessayez.",
    "studioContextRetry": "Réessayer",
    "studioContextSwitchStudio": "Changer de studio",
    "unreadConversation": "Conversation non lue avec {{name}}",
    "unreadConversationCount": "Conversation non lue avec {{name}}, {{count}} messages non lus",
    "session": {
      "filterBarTitle": "Filtré : session en expiration",
      "filterBarHint": "Affiche les fils dont la session expire bientôt ou est déjà expirée pour le texte libre.",
      "clearSessionFilter": "Afficher tous les chats",
      "filterEmpty": "Aucun chat ne correspond au filtre session dans cette vue. Réinitialisez le filtre ou changez de studio.",
      "bannerExpiringTitle": "Session WhatsApp bientôt close",
      "bannerExpiringBody": "Les réponses en texte libre restent possibles pendant {{time}}. Ensuite, Meta peut exiger un modèle approuvé ou un nouveau message du client.",
      "bannerExpiredTitle": "Session WhatsApp close pour le texte libre",
      "bannerExpiredBody": "Ce fil est en dehors de la fenêtre client de 24 h habituelle. L’envoi peut échouer tant qu’un modèle approuvé n’est pas utilisé ou que le client n’écrit pas à nouveau.",
      "composerExpiredHelp": "Les réponses libres sont bloquées. Choisissez un modèle de message approuvé dans le panneau de brouillon ci-dessus.",
      "composerClosedInstagram": "Cela fait plus de 7 jours. Demandez au client de vous écrire à nouveau avant de pouvoir répondre.",
      "rowAriaExpiringWhatsApp": "Session WhatsApp bientôt expirée",
      "rowAriaExpiredWhatsApp": "Session WhatsApp expirée pour le texte libre",
      "rowTooltipExpiringWhatsApp": "Session se ferme dans {{time}}",
      "rowTooltipExpiredWhatsApp": "Session expirée — modèles ou nouveau message client",
      "rowAriaSessionExpiring": "Session de messagerie bientôt expirée",
      "rowAriaSessionExpired": "Session de messagerie expirée pour le texte libre",
      "rowTooltipExpiringInstagram": "La fenêtre de réponse se ferme dans {{time}}",
      "rowTooltipExpiredInstagram": "Hors 24 h — réponses manuelles uniquement, jusqu'à 7 jours",
      "bannerExpiringTitleInstagram": "Fenêtre de réponse bientôt fermée",
      "bannerExpiringBodyInstagram": "Réponses encore possibles pendant {{time}}. Répondez vite ou attendez un nouveau message du client.",
      "bannerExpiredTitleInstagram": "Hors de la fenêtre de réponse de 24 heures",
      "bannerExpiredBodyInstagram": "En dehors de la fenêtre de 24 heures (jusqu'à 7 jours) : Réponse manuelle uniquement, ou Examiner la réponse suggérée, la modifier et envoyer manuellement.",
      "bannerClosedTitleInstagram": "Impossible de répondre sur Instagram",
      "bannerClosedBodyInstagram": "Cela fait plus de 7 jours. Demandez au client de vous écrire à nouveau.",
      "headerSupportWindowInstagram": "Fenêtre support · il y a {{time}}"
    },
    "customerInfo": "Info Cliente",
    "customerInfoTitle": "Info Cliente",
    "details": {
      "title": "Détails du client",
      "show": "Afficher les détails du client",
      "hide": "Masquer les détails du client",
      "collapseAria": "Réduire le panneau des détails client",
      "expandAria": "Développer le panneau des détails client",
      "resizeAria": "Redimensionner le panneau des détails client",
      "placeholderLoading": "Chargement des détails du client…",
      "sectionGeneral": "Général",
      "sectionStudios": "Studios",
      "sectionDocuments": "Documents",
      "sectionClasses": "Cours",
      "upcomingClassesToggle": "Cours à venir les plus proches",
      "upcomingClassesEmpty": "—",
      "classesLast": "Dernier",
      "classesNext": "Prochain",
      "confirmIdentity": "Confirmer l'identité",
      "confirmIdentityHelp": "Marque ce client comme identifié dans cette conversation et débloque les actions d’approbation de brouillon."
    },
    "composer": {
      "collapseAria": "Réduire le champ de réponse",
      "expandAria": "Développer le champ de réponse"
    },
    "escalated": "Réaffecté",
    "escalatedDraftPending": "Réponse suggérée prête — à examiner avant envoi",
    "escalationKind": {
      "soft": "À examiner",
      "hard": "Prise en charge humaine"
    },
    "escalationFamily": {
      "human_requested": "Client a demandé une personne",
      "tool_or_platform_failure": "Échec d’outil ou de plateforme",
      "availability_unverified": "Disponibilité non vérifiée",
      "no_availability": "Aucun cours réservable",
      "account_read_failed": "Lecture du compte échouée",
      "conversation_stall": "Conversation bloquée",
      "low_confidence_or_scope": "Hors périmètre ou incertitude",
      "frustration": "Client frustré",
      "max_exchanges": "Nombre max d’échanges atteint",
      "identity_verification": "Vérification d’identité nécessaire",
      "policy_restricted": "Sujet restreint",
      "manual": "Escaladé manuellement",
      "ai_unavailable": "IA indisponible",
      "named_set_unfinished": "Annulation non terminée",
      "cancellation_refused": "Annulation refusée"
    },
    "leadWhy": {
      "structured": "Depuis une pub",
      "inferred": "Déduit"
    },
    "campaignLeadPreparation": {
      "title": "Accueil de campagne préparé",
      "closedTitle": "Épisode de campagne clôturé",
      "activeTitle": "Accueil de campagne actif",
      "notSent": "Non envoyé",
      "closed": "Clôturé",
      "active": "Actif",
      "activeBody": "Le fournisseur a accepté le message de bienvenue de la campagne. L’épisode attend le choix du forfait par le client.",
      "closedBody": "L’automatisation de campagne est arrêtée pour cet épisode.",
      "terminal": {
        "purchase_verified": "Achat vérifié",
        "member_discovered": "Membre existant trouvé",
        "explicit_decline": "Refus du client",
        "manager_takeover": "Prise en charge par un responsable"
      },
      "awaitingPack": "En attente du choix du forfait",
      "packSelected": "Forfait sélectionné : {{name}}",
      "linkReady": "Lien d’achat prêt : {{name}}",
      "purchaseClaimUnverified": "Achat signalé · vérification requise",
      "bodyAuto": "Les données de la campagne sont figées. Le message de bienvenue est en attente d’envoi automatique.",
      "bodyManual": "Les données de la campagne sont figées. Vérifiez et envoyez le message de bienvenue depuis la réponse suggérée ci-dessous.",
      "modeAuto": "Préparation automatique · envoi en attente",
      "modeManual": "Préparation manuelle · vérification requise",
      "campaign": "{{name}} · version {{version}}",
      "campaignFallback": "Campagne · version {{version}}",
      "packs": "Packs préparés",
      "purchaseLink": "Lien d’achat"
    },
    "resolved": "Résolu",
    "resolvedButton": "Marquer résolu",
    "resolve": "Résoudre",
    "escalate": "Transmettre aux niveaux supérieurs",
    "archive": "Archive",
    "moreChatActions": "Plus d'actions de chat",
    "chatIdLabel": "ID de conversation",
    "loadingOlder": "Chargement des anciens messages",
    "loadOlderMessages": "Charger les messages plus anciens",
    "customerFallback": "Client",
    "senderSystem": "Système",
    "loadingMessages": "Chargement des messages",
    "draftBlockedDefault": "Le client doit être identifié avant d'approuver les actions du compte.",
    "draftBlockedHumanHandling": "Cette conversation a déjà été transmise à votre équipe — cette suggestion répond peut-être à un message antérieur.",
    "draftStaleHeadReleased": "La conversation a évolué depuis que cette réponse a été rédigée.",
    "draftStaleHeadReleasedRecovery": "Éditez-la avant de l'envoyer, ou répondez avec vos propres mots.",
    "draftStaleHeadReleasedRefusal": "Cette réponse suggérée n'est plus à jour — la conversation a évolué depuis qu'elle a été rédigée. Modifiez le texte avant de l'envoyer, ou répondez avec vos propres mots.",
    "listJustNow": "À l'instant",
    "listMinsShort": "Il y a {{count}}m",
    "listHoursShort": "Il y a {{count}}h",
    "listDaysShort": "Il y a {{count}}d",
    "threadToday": "Aujourd’hui",
    "threadYesterday": "Hier",
    "emojiSearchPlaceholder": "Rechercher un emoji",
    "emojiSkinToneAria": "Changer la teinte de peau des emojis",
    "emojiCategoryRecent": "Emojis récents",
    "emojiCategoryAll": "Tous les emojis",
    "emojiCategorySmileys": "Smileys et personnes",
    "emojiCategoryPeople": "Gestes et personnes",
    "emojiCategoryHearts": "Cœurs et célébrations",
    "emojiCategoryTravel": "Voyages et lieux",
    "emojiCategorySymbols": "Symboles et statut",
    "resolvedModalConfirm": "Marquer résolu",
    "typeMessagePlaceholder": "Taper un message …",
    "editTitle": "éditer",
    "senderAi": "AI",
    "senderTeam": "Team",
    "connectPlatformHint": "Connectez une plateforme de réservation {{listingFragment}} dans Paramètres → Canaux pour afficher le contexte du membre ou du voyageur lié ici.",
    "connectPlatformListingFragment": "ou l'annonce",
    "connectPlatformListingEmpty": "",
    "searchManually": "Rechercher manuellement",
    "trial": "Essai",
    "firstTrial": {
      "staffHint": {
        "scenario1": "Premier essai — scénario 1 (pas de compte sur la plateforme de réservation). Équipe uniquement.",
        "scenario2": "Premier essai — scénario 2 (compte existant, nouveau dans votre studio). Équipe uniquement."
      },
      "linksNotReady": {
        "title": "Lien de premier essai manquant",
        "reason": {
          "missing_trial_registration_link": "Ajoutez le lien d’inscription / d’essai avant que Copilot puisse envoyer automatiquement ce parcours d’essai.",
          "missing_studio_trial_booking_link": "Ajoutez le lien du studio avant que Copilot puisse envoyer automatiquement ce parcours d’essai.",
          "unknown": "Ajoutez les liens de premier essai requis avant que Copilot puisse envoyer automatiquement ce parcours d’essai."
        },
        "cta": "Ouvrir Infos générales"
      }
    },
    "completedWriteClash": {
      "title": "Le brouillon contredit une action déjà effectuée",
      "body": "La plateforme de réservation confirme que cette action a été effectuée lors de ce tour, mais le brouillon indique toujours au client qu'il n'y a pas droit. Modifiez la réponse avant de l'approuver."
    },
    "groundedFailure": {
      "title": "La réponse factuelle doit être vérifiée",
      "facts": "Faits trouvés",
      "reason": "Problème de vérification"
    },
    "proposedAction": {
      "FIRST_TRIAL_LINKS_NOT_READY": "Configurez les liens d’essai dans Données du studio avant que Copilot puisse envoyer automatiquement ce parcours d’essai.",
      "GROUP_MANUAL_FULFILLMENT": "Les réservations de groupe ou d’équipe nécessitent une prise en charge manuelle par l’équipe du studio."
    },
    "campaignSend": {
      "campaign_ended": "Cette campagne est terminée ou n’est plus active, le message de bienvenue n’a donc pas été envoyé.",
      "instagram_window_closed": "La fenêtre de réponse Instagram de ce client est fermée, le message de bienvenue n’a donc pas été envoyé.",
      "human_handling": "Un membre de l’équipe a repris cette conversation, le message de bienvenue de la campagne n’a donc pas été envoyé.",
      "customer_is_member": "Ce client est déjà membre, le message de bienvenue de la campagne n’a donc pas été envoyé.",
      "newer_customer_message": "Le client a écrit à nouveau après la préparation de ce message de bienvenue, il n’a donc pas été envoyé.",
      "campaign_paused": "L’envoi des campagnes est actuellement suspendu pour ce studio, le message de bienvenue n’a donc pas été envoyé.",
      "instagram_not_connected": "La connexion Instagram de ce studio n’a pas pu être confirmée. Vérifiez la connexion dans les paramètres, puis réessayez.",
      "send_in_progress": "Un autre envoi pour ce client est encore en cours. Attendez qu’il se termine avant de réessayer ; cela peut prendre une minute.",
      "cooldown_or_capacity": "Ce client a atteint la limite de messages de bienvenue de campagne pour le moment, le message n’a donc pas été envoyé.",
      "draft_changed": "Ce brouillon ne correspond plus au message de campagne préparé. Actualisez la conversation avant de réessayer.",
      "group_booking_active": "Une proposition de réservation de groupe est encore ouverte dans cette conversation, le message de bienvenue de la campagne n’a donc pas été envoyé. Traitez ou abandonnez d’abord cette proposition.",
      "no_customer_message": "Il n’y a pas encore de message du client dans cette conversation, le message de bienvenue de la campagne n’a donc pas été envoyé.",
      "internal": "Le message de bienvenue de la campagne n’a pas pu être envoyé, car une vérification interne a échoué. Réessayez plus tard ou contactez le support.",
      "customer_refused": "Ce client a refusé la campagne, aucun message de bienvenue n’a donc été envoyé.",
      "customer_reply_pending_check": "La dernière réponse du client est encore en cours de vérification, le message de bienvenue n’a donc pas encore été envoyé. Réessayez dans un instant.",
      "campaign_updated": "La campagne a été modifiée après la préparation de ce message de bienvenue, il n’a donc pas encore été envoyé. Le message correspond maintenant à l’offre actuelle. Vérifiez-le, puis appuyez de nouveau sur Envoyer.",
      "campaign_updated_edited": "La campagne a été modifiée après la préparation de ce message de bienvenue, il n’a donc pas encore été envoyé. Votre texte modifié a été conservé. Vérifiez-y les formules et les prix, puis appuyez de nouveau sur Envoyer.",
      "welcome_too_long": "Ce message de bienvenue est trop long pour un seul message Instagram, il n’a donc pas été envoyé. Raccourcissez-le, puis appuyez de nouveau sur Envoyer.",
      "welcome_capacity_reached": "Ce client a déjà reçu le maximum de deux messages de bienvenue de campagne de ce studio, le message n’a donc pas été envoyé.",
      "welcome_cooldown_active": "Ce client a reçu un message de bienvenue de campagne de ce studio au cours des 30 derniers jours, le message n’a donc pas été envoyé. Un nouveau message de bienvenue sera possible une fois ces 30 jours écoulés.",
      "campaign_episode_active": "Une conversation de campagne avec ce client est encore en cours, un deuxième message de bienvenue n’a donc pas été envoyé.",
      "campaign_episode_ended": "Une conversation de campagne précédente avec ce client est déjà terminée, le message de bienvenue n’a donc pas été envoyé.",
      "welcome_delivery_unknown": "Un envoi précédent de ce message de bienvenue a peut-être déjà atteint le client, il n’a donc pas été renvoyé."
    },
    "confirmObject": {
      "cardTitleBooking": "Réservation à confirmer",
      "cardTitleCancel": "Annulation à confirmer",
      "cardTitleRebook": "Annuler et réserver",
      "cardTitleIdentity": "Identité à confirmer",
      "customerLabel": "Client",
      "classLabel": "Cours",
      "classIdLabel": "Id du cours",
      "dateLabel": "Date",
      "timeLabel": "Heure",
      "instructorLabel": "Instructeur",
      "bookingRefLabel": "Réf. de réservation",
      "rebookFromLabel": "Annuler",
      "rebookToLabel": "Réserver",
      "cancelSetAnd": "et",
      "cancelSetUnknownClass": "Un cours (détails indisponibles)",
      "contactLabel": "Contact",
      "contactMissing": "Aucun e-mail, téléphone ou identifiant Instagram sur cette conversation.",
      "itineraryPartial": "Le nom du cours, la date et l’heure locale ne sont pas encore dans cette charge utile. Confirmer exécute tout de même l’écriture approuvée.",
      "confirmBooking": "Confirmer la réservation",
      "confirmCancellation": "Confirmer l’annulation",
      "confirmRebook": "Confirmer l’annulation et la réservation",
      "confirmIdentity": "Confirmer l’identité",
      "abort": "Abandonner",
      "abortUnavailable": "L’abandon n’est pas encore disponible. Confirmer exécute toujours ; masquer cette carte n’annulerait pas l’écriture en attente.",
      "bookingInProgress": "Réservation en cours…",
      "bookingStillRunning": "La réservation est toujours en cours. Vous pouvez continuer dans d'autres conversations ; le résultat s'affichera ici.",
      "abortIdentityHint": "Ne confirme pas l’identité. Aucune requête n’est envoyée.",
      "claimLive": "{{name}} est en train de finaliser cette action. Confirmer et Abandonner sont momentanément indisponibles.",
      "claimLiveNoName": "Un autre gestionnaire est en train de finaliser cette action. Confirmer et Abandonner sont momentanément indisponibles.",
      "claimStale": "La dernière tentative ne s’est pas terminée. Vous pouvez réessayer."
    },
    "groupBooking": {
      "listBadgeAria": "Demande de groupe ou d’équipe",
      "listTooltip": "Cette conversation a un brouillon en attente pour une demande de réservation de type groupe ou événement d’équipe.",
      "draftCardTitle": "Groupe / événement d’équipe",
      "cardTitle": "Groupe / événement d’équipe",
      "extractedPartySize": "Taille du groupe notée : {{count}}",
      "partySize": "Taille du groupe notée : {{count}}",
      "participantsLabel": "Participants",
      "checklistLabel": "Liste de contrôle manager",
      "checklistUnknown": "Élément : {{key}}",
      "overrideReasonUnknown": "{{key}}",
      "status": {
        "collecting": "Collecte des informations de la liste",
        "awaitingManager": "En attente de relecture manager",
        "awaitingApproval": "En attente de votre validation",
        "running": "Automatisation en cours",
        "done": "Terminé",
        "failed": "Échec de l’automatisation",
        "manualFallback": "Traitement manuel requis",
        "notApplicable": "Non applicable"
      },
      "checklist": {
        "party_size": "Clarifier l’effectif final et les tranches d’âge",
        "date_window": "Confirmer les dates ou la plage horaire souhaitée",
        "offering_type": "Confirmer le type de cours, le forfait ou le périmètre de location privée",
        "deposit_or_po": "Acompte, bon de commande ou contact de facturation le cas échéant",
        "bill_to": "Entité facturée et informations fiscales si nécessaire",
        "roster_complete": "Confirmer que la liste est complète (noms et contacts)",
        "class_slot": "Confirmer le cours, la séance ou le créneau",
        "book_without_product": "Enregistrer la réservation sans produit lié si nécessaire",
        "invoice_externally": "Facturer en dehors de la plateforme si requis",
        "terms_confirm_on_site": "Confirmer les conditions sur place si nécessaire"
      },
      "overrideReason": {
        "group_policy_overrode_auto_send": "L’envoi automatique a été remplacé pour ce tour par votre politique groupe / équipe — vérifiez avant d’envoyer."
      }
    },
    "escalateModalTitle": "Faire remonter la conversation",
    "escalateModalBody": "Cela informera l'équipe pour un suivi manuel.",
    "resolvedModalTitle": "Marquer comme résolu",
    "resolvedModalBody": "Cette conversation sera marquée comme résolue.",
    "filter": {
      "panelTitle": "Filtre",
      "panelDescription": "Sélectionnez les filtres de discussion et appliquez-les à la liste de conversations.",
      "closeAria": "Fermer le panneau de filtre",
      "sectionStatus": "ÉTAT",
      "sectionIntention": "INTENTION",
      "sectionCustomerId": "Identifiant du Client",
      "sectionChannel": "Profilé",
      "statusUnread": "Non lu",
      "statusNeedsReview": "Requiert une évaluation",
      "statusEscalated": "Réaffecté",
      "statusAiHandled": "AI Handled",
      "statusResolved": "Résolu",
      "statusNeedsFollowup": "Nécessite un suivi"
    },
    "sort": {
      "newest": "Les plus récents",
      "oldest": "Les plus anciens",
      "unreadFirst": "Non lu en premier",
      "escalatedFirst": "Remontée en premier",
      "sessionExpiringFirst": "Urgence de session",
      "byStatus": "Statut"
    },
    "intentChip": {
      "newBooking": "Nouvel inscriptions/Réservation",
      "rebooking": "Modifier la réservation",
      "cancellation": "Annulation",
      "generalInfo": "Infos",
      "schedule": "Calendrier",
      "membership": "Adhésion",
      "other": "D’autres"
    },
    "customerId": {
      "identified": "Identified",
      "idPending": "ID en attente",
      "unmatched": "Autres courriels",
      "generalInquiry": "Question d'ordre général"
    },
    "leadBadge": {
      "label": "Prospect"
    },
    "channel": {
      "instagram": "Instagram",
      "whatsapp": "WhatsApp",
      "facebook": "Facebook Messenger",
      "email": "E-mail"
    },
    "email": {
      "from": "De",
      "to": "À",
      "cc": "Cc",
      "authorCustomer": "Client",
      "subject": "Objet",
      "sendFromMailbox": "Les réponses sont envoyées depuis {{mailbox}}",
      "emptyConnectHint": "Connectez l'e-mail dans Paramètres → Canaux ou depuis l'en-tête pour voir les fils ici.",
      "deliveryFailed": "Échec de livraison",
      "showPreviousMessages": "Afficher les messages précédents",
      "hidePreviousMessages": "Masquer les messages précédents",
      "inlineImageUnavailable": "Image intégrée indisponible",
      "attachmentDownloadFailed": "Impossible de télécharger la pièce jointe",
      "grantExpiredBannerTitle": "Reconnexion e-mail requise",
      "grantExpiredBannerBody": "L'envoi est désactivé tant que la boîte mail n'est pas reconnectée.",
      "grantExpiredBannerCta": "Ouvrir Paramètres → Canaux",
      "grantExpiredComposer": "Reconnectez l'e-mail dans Paramètres pour envoyer des messages.",
      "composer": {
        "send": "Envoyer",
        "replyAll": "Répondre à tous",
        "bold": "Gras",
        "italic": "Italique",
        "underline": "Souligné",
        "bulletList": "Liste à puces",
        "numberedList": "Liste numérotée",
        "link": "Insérer un lien",
        "insertImage": "Insérer une image",
        "attachFile": "Joindre un fichier",
        "bodyAria": "Corps du message e-mail",
        "linkPrompt": "Saisir l'URL du lien",
        "linkUrlInvalid": "Saisissez une adresse web valide (ex. example.com)",
        "imageTypeError": "Choisissez un fichier image",
        "attachmentMaxCount": "{{count}} pièces jointes maximum",
        "attachmentOversize": "Pièce jointe trop volumineuse",
        "attachmentUploadFailed": "Échec du téléversement de la pièce jointe",
        "attachmentRemoveFailed": "Impossible de retirer la pièce jointe",
        "inlineImageNotReady": "L'image intégrée n'est pas prête à être envoyée. Attendez si un téléversement est en cours, ou supprimez-la et réessayez.",
        "removeAttachment": "Retirer {{name}}",
        "bodyCharCount": "{{count}} / {{max}} caractères"
      }
    },
    "provenance": {
      "autoAi": "Auto AI",
      "approvedAi": "IA approuvée",
      "team": "Team",
      "sessionNudge": "OktoGo — relance de session"
    },
    "infoRow": {
      "phone": "Téléphone",
      "instagram": "Instagram",
      "email": "E-mail"
    },
    "handling": {
      "autoSendAll": "Tous les sujets : envoi automatique",
      "autoSendNone": "Tous les sujets : brouillon pour approbation",
      "autoSendMixed": "Mixte : certains envoient automatiquement, d'autres ont besoin d'approbation",
      "teamStyleOn": "Style partenaire",
      "teamStyleOff": "Style partenaire",
      "autoLabelPrefix": "Étiquette automatique : {{label}}",
      "tooltip": "Comment l'IA gère ce fil dans OktoGo. La livraison par canal utilise toujours votre compte professionnel WhatsApp ou Instagram connecté."
    },
    "archiveChatError": "Impossible d'archiver le chat",
    "archiveChatSuccess": "Chat archivé",
    "archiveDialogTitle": "Archiver la discussion ?",
    "archiveDialogBody": "Êtes-vous sûr de vouloir archiver ce Spot?",
    "archiveDangerTitle": "Zone dangereuse",
    "archiveDangerBody": "Cette action est irréversible dans l'application. La conversation sera supprimée de votre liste de discussion et les membres de l'équipe ne la verront plus ici. L'historique des messages est conservé à des fins de conformité, mais peut ne pas être accessible à partir de cette interface.",
    "archiveAnyway": "Archiver quand même",
    "customerWroteAgain": {
      "notice": "Le client a écrit à nouveau. Cette confirmation n'est plus active. L'assistant lit son message."
    },
    "emptyStateTitle": "Sélectionner une conversation",
    "emptyStateSubtitle": "Choisissez dans la liste pour afficher les messages",
    "saveEdit": "Sauvegarder",
    "messageEdited": "modifié",
    "attachmentPhotoVideo": "Photo/Vidéo",
    "attachmentDocument": "Document",
    "attachmentUpload": "Importer un fichier",
    "noMessages": "Pas de messages à afficher",
    "draftApproveSend": "Envoyer",
    "identityPendingHint": "Identité en attente —",
    "identityApprovalSuccess": "Identité confirmée. Vous pouvez maintenant approuver et envoyer le brouillon.",
    "identityVerifiedMilestone": "Identité vérifiée",
    "identityApprovalFailed": "Nous n’avons pas pu confirmer l’identité. Réessayez dans un instant.",
    "identityApprovalNotAvailable": "Aucun profil client lié pour le moment. Attendez la confirmation du client ou liez d’abord un profil, puis réessayez.",
    "identityInvalidState": "L’identité n’est pas en attente d’approbation pour cette conversation. Actualisez et réessayez.",
    "draftEdit": "éditer",
    "draftDeliveredDiffers": "Le texte envoyé diffère du brouillon approuvé.",
    "draftRegenerate": "Regénérer",
    "reject": "Rejeter",
    "reportIssue": "Signaler un problème",
    "reportCopilotIssueMenu": "Signaler un problème Copilot",
    "feedback": {
      "dialogTitleReject": "Rejeter la réponse suggérée",
      "dialogTitleReport": "Signaler un problème Copilot",
      "dialogDescriptionReject": "Dites-nous ce qui n'a pas fonctionné. La réponse suggérée sera supprimée après l'envoi.",
      "dialogDescriptionReport": "Décrivez le problème. Votre réponse suggérée restera disponible pour modification ou envoi.",
      "categoryLegend": "Quel était le problème ?",
      "categoryRequired": "Choisissez une catégorie pour continuer.",
      "category": {
        "wrongInformation": "Information incorrecte ou obsolète",
        "wrongTone": "Ton ou formulation inadaptés",
        "shouldHaveAsked": "Aurait dû me demander d’abord",
        "bookingMistake": "Erreur de réservation",
        "misunderstood": "Demande mal comprise",
        "other": "Autre"
      },
      "detailsLabel": "Détails (facultatif)",
      "detailsPlaceholder": "Que Copilot aurait-il dû faire autrement ?",
      "includeContext": "Inclure le contexte de la conversation",
      "piiWarning": "N’ajoutez pas de captures avec numéros de téléphone ou données de paiement clients.",
      "wrongInformationHint": "Vous pouvez mettre à jour les informations du studio dans",
      "studioDataLink": "Données studio",
      "cancel": "Annuler",
      "submitReject": "Rejeter",
      "submitReport": "Envoyer le signalement",
      "submitting": "Envoi…",
      "submitThanks": "Merci — votre retour nous aide à améliorer Copilot.",
      "errorGeneric": "Impossible d’envoyer votre retour. Réessayez.",
      "errorNoPendingDraft": "Aucun brouillon en attente à rejeter.",
      "errorRateLimited": "Vous avez envoyé plusieurs signalements récemment. Patientez quelques minutes.",
      "errorForbidden": "Vous n’avez pas l’autorisation d’envoyer un retour pour ce chat.",
      "reportedDraftLabel": "Réponse suggérée signalée",
      "errorAttachmentUpload": "Impossible d’envoyer cette image. Veuillez réessayer.",
      "errorUnsupportedFileType": "Type de fichier non pris en charge",
      "attachmentsLabel": "Captures d’écran (facultatif)",
      "addAttachment": "Ajouter une image",
      "attachmentOversize": "Chaque image doit faire 2 Mo ou moins.",
      "attachmentMaxCount": "Vous pouvez joindre jusqu’à 3 images.",
      "attachmentsDropHint": "Collez ou déposez des images ici (PNG, JPEG, WebP ; 2 Mo max. chacune).",
      "scenarioSuggestedLegend": "Scénario de test (suggéré)",
      "scenarioConfidence": "Confiance : {{level}}",
      "scenarioConfidenceHigh": "Élevée",
      "scenarioConfidenceMedium": "Moyenne",
      "scenarioConfidenceLow": "Faible",
      "scenarioChange": "Modifier",
      "scenarioSkipMapping": "Je ne suis pas sûr / ignorer le mapping",
      "scenarioNoSuggestion": "Aucune correspondance automatique pour cette catégorie. Choisissez manuellement ou ignorez.",
      "scenarioPickManual": "Choisir un scénario"
    },
    "whatsappTemplatePicker": {
      "title": "Sélectionner un modèle approuvé",
      "aria": "Sélectionner un modèle approuvé",
      "searchPlaceholder": "Rechercher des modèles de message…",
      "select": "Sélectionner",
      "insert": "Insérer",
      "inWindowHint": "Le texte du modèle sera inséré dans votre brouillon. Envoyez-le avec Approuver et envoyer comme d’habitude."
    },
    "whatsappTemplate": {
      "panelTitle": "Modèle de message",
      "panelSubtitle": "Hors de la fenêtre de 24 h, seuls les modèles approuvés par Meta peuvent joindre le client.",
      "loading": "Chargement des modèles…",
      "loadError": "Impossible de charger les modèles WhatsApp.",
      "retry": "Réessayer",
      "emptyApproved": "Aucun modèle approuvé pour ce studio. Ajoutez ou faites approuver des modèles dans Paramètres → Canaux.",
      "templateLabel": "Modèle",
      "templatePlaceholder": "Choisir un modèle",
      "variableLabel": "Variable {{index}}",
      "variableCountError": "Ce modèle nécessite {{count}} variable(s).",
      "previewLabel": "Aperçu",
      "sendButton": "Envoyer le modèle",
      "sendSuccess": "Message modèle mis en file d’attente.",
      "sendError": "Impossible d’envoyer le modèle. Veuillez réessayer.",
      "approveBlockedTooltip": "L’approbation en texte libre est bloquée. Envoyez un modèle WhatsApp approuvé ci-dessous.",
      "suggestedLabel": "Suggéré pour ce fil",
      "llmSuggestedHelper": "Suggéré par l’IA pour ce fil.",
      "suggestionRationale": {
        "supportFollowup": "Relance sur un message client récent",
        "aiHandoff": "Transfert à un membre de l’équipe après escalade",
        "bookingCancelled": "Contexte d’annulation de réservation",
        "classReminder": "Rappel de cours ou de réservation",
        "bookingConfirmed": "Confirmation de réservation",
        "waitlist": "Place en liste d’attente disponible",
        "reengagement": "Relance après résolution"
      }
    },
    "insertMessage": {
      "chooseTemplate": "Choisir un modèle de message"
    },
    "messageTemplate": {
      "panelTitle": "Modèle de message",
      "expiredEmptyTitle": "Fenêtre de messagerie fermée",
      "expiredEmptyBody": "Choisissez un modèle WhatsApp approuvé pour joindre ce client.",
      "editVariables": "Modifier les variables"
    },
    "feedbackEditor": {
      "bold": "Gras",
      "italic": "Italique",
      "bulletList": "Liste à puces",
      "orderedList": "Liste numérotée",
      "emoji": "Insérer un emoji",
      "markdownHint": "Le formatage utilise Markdown. Utilisez Aperçu pour voir le rendu.",
      "showPreview": "Aperçu",
      "hidePreview": "Modifier"
    },
    "draftRegenerateTitle": "Regénérer",
    "draftAiDraft": "Réponse suggérée",
    "draftReviewing": "Réponse suggérée — en cours de révision",
    "draftReview": "Examiner",
    "composeManualReply": "Réponse manuelle",
    "composeManualReplyPlaceholder": "Saisissez votre message manuellement",
    "draftSave": "Enregistrer en brouillon",
    "draftRegenerateFailed": "La régénération a échoué.",
    "draftRegenerateFailedRetry": "Échec. Veuillez essayer à nouveau.",
    "draftRegenerateWsFailed": "Échec de la régénération du brouillon.",
    "draftApproveFailed": "Nous n’avons pas pu approuver et envoyer ce brouillon. Réessayez dans un instant.",
    "draftAbortFailed": "Nous n’avons pas pu abandonner cette action en attente. Réessayez dans un instant.",
    "draftSaveFailed": "Nous n’avons pas pu enregistrer le brouillon. Réessayez dans un instant.",
    "replySendFailed": "Nous n’avons pas pu envoyer votre message : il a été remis dans le champ pour que vous puissiez réessayer.",
    "replyTooLong": "Ce message est trop long pour être envoyé. Raccourcissez-le ou joignez le texte en pièce jointe.",
    "replyTooLongDelta": "Ce message dépasse la limite de {{over}} caractères. Raccourcissez-le ou joignez le texte en pièce jointe.",
    "statusUpdateFailed": "Nous n’avons pas pu mettre à jour le statut. Réessayez dans un instant.",
    "messageEditFailed": "Nous n’avons pas pu enregistrer cette modification. Réessayez dans un instant.",
    "messageDeliveryFailedTitle": "Ce message n’est pas parvenu au client",
    "messageDeliveryFailedBody": "Il reste visible ici, mais WhatsApp ou Instagram a bloqué l’envoi. Souvent : droits Meta, revue « agent humain », ou fenêtre des 24 dernières heures.",
    "messageDeliveryFailedOtherThread": "Cet envoi concernait un autre fil (id commençant par {{id}}). Ouvrez-le dans la liste si vous devez reprendre le contact.",
    "messageDeliveryFailedHumanAgentTitle": "Impossible de délivrer cette réponse Instagram",
    "messageDeliveryFailedHumanAgentBody": "L'agent humain Instagram n'est pas encore approuvé pour cette application, ce message n'a donc pas pu atteindre le client. Demandez-lui de vous écrire à nouveau pour rouvrir les réponses gratuites, ou continuez sur WhatsApp si ce canal est connecté.",
    "messageDeliveryFailedProviderDetail": "Retour d’Instagram :",
    "messageDeliveryFailedBubble": "N'est pas parvenu au client",
    "actionLogExpand": "Développer le journal des actions de l'IA",
    "actionLogCollapse": "Réduire le journal des actions de l'IA",
    "actionLogTitle": "Journal des actions",
    "actionLogCountOne": "{{count}} action",
    "actionLogCountOther": "{{count}} actions",
    "actionLogAttribution": "par {{name}}",
    "actionLogLabels": {
      "draft_approved": "Brouillon approuvé et envoyé",
      "draft_edited": "Brouillon modifié",
      "draft_edited_and_sent": "Brouillon modifié et envoyé",
      "draft_regenerated": "Brouillon régénéré",
      "draft_aborted": "Brouillon interrompu avant l'envoi",
      "manual_reply_sent": "Réponse manuelle envoyée",
      "whatsapp_template_sent": "Modèle WhatsApp envoyé",
      "auto_reply_sent": "Réponse automatique envoyée",
      "status_changed": "Statut modifié",
      "identity_approved": "Identité confirmée",
      "faq_created": "FAQ créée",
      "faq_edited": "FAQ modifiée",
      "faq_deleted": "FAQ supprimée",
      "toggle_changed": "Paramètre modifié",
      "menu_answered": "Menu répondu"
    },
    "registrationTitle": "Enregistrement",
    "registrationSendLink": "Lien d'enregistrement",
    "registrationAssisted": "Enregistrement assisté",
    "registrationSendLinkButton": "Ajouter un lien",
    "refundApplicable": "Encore dans les temps — le crédit de cours ou le pass devrait revenir.",
    "refundNotApplicable": "Trop près du début du cours — aucun crédit de cours ne revient.",
    "richCards": {
      "availabilitySpots": "{{spots}} places",
      "availabilitySpotsWarning": "{{spots}} places ⚠️",
      "bookingNoFee": "Aucun frais facturé",
      "bookingNewClient": "Nouveau compte client créé",
      "bookingConfirmedTitle": "Réservation confirmée",
      "bookingCreditsLine": "Crédits utilisés : {{used}} · Restants : {{remaining}}",
      "rebookingCancelled": "Annulé",
      "rebookingRebooked": "Reprogrammé",
      "policyRequiredNotice": "Préavis requis : {{value}}",
      "policyTimeUntilClass": "Temps avant le cours : {{value}}",
      "policyLateFee": "Frais de retard : {{value}}",
      "scheduleStatusOpen": "Ouvert",
      "multiBookedTitle": "{{count}} cours réservés",
      "membershipLabel": "Abonnement : {{name}}",
      "membershipUsedProgress": "{{used}} / {{total}} utilisés",
      "membershipRemaining": "Restants : {{remaining}}",
      "membershipExpires": "Expire : {{date}} ({{days}} jours)",
      "membershipBookNext": "Réserver le prochain cours",
      "membershipRenew": "Renouveler — {{label}} {{price}}"
    },
    "customerPanel": {
      "noListingChannel": "Aucun canal d'annonce connecté",
      "noBookingPlatform": "Aucune plateforme de réservation connectée",
      "memberCustomerId": "Identifiant du membre / client",
      "secondaryReference": "Référence secondaire",
      "noMatchingGuest": "Aucun enregistrement de voyageur correspondant",
      "noMatchingCustomer": "Aucun dossier client correspondant",
      "joinedLineStr": "{{line}} · {{platform}}",
      "guestNotFoundIn": "Voyageur introuvable à {{platform}}",
      "connectedPlatform": "Connecté · {{platform}}",
      "eversportsCustomerId": "ID client Eversports",
      "genericCustomerId": "{{platform}} ID client",
      "mindbodyClientId": "ID client Mindbody",
      "bsportMemberId": "ID de membre Bsport",
      "partnerNetworkId": "Réseau de partenaires",
      "customerNotFoundIn": "Client introuvable dans {{platform}}"
    }
  },
  "studioData": {
    "activeStudioLimitReached": "Maximum 5 studios actifs. Archivez un studio avant d’en créer un autre.",
    "readOnlyBanner": "Vous avez un accès en lecture seule à {{noun}}.",
    "noStudiosLinked": "Aucun studio lié à ce compte.",
    "notConfiguredTab": "Non configuré",
    "searchStudiosAria": "Rechercher des studios",
    "tabClasses": "Classes",
    "tabFaq": "FAQ",
    "tabGeneral": "Infos",
    "tabPolicies": "Politique",
    "tabPrices": "Tarifs",
    "tabTeam": "Équipe",
    "tabUsers": "Utilisateurs",
    "tabCampaigns": "Campagnes",
    "readOnlyHint": "Seuls les propriétaires et les gestionnaires peuvent le modifier.",
    "import": {
      "action": "Importer",
      "actionEmpty": "Importer depuis un document",
      "titleFaq": "Importer dans la FAQ",
      "titlePolicies": "Importer dans les politiques",
      "titleGeneral": "Importer dans les infos générales",
      "tabPaste": "Coller le texte",
      "tabUpload": "Téléverser un fichier",
      "uploadComingSoon": "Le téléversement arrive bientôt. Collez votre texte pour l'instant.",
      "pastePlaceholder": "Collez votre manuel, page FAQ ou document de politique ici…",
      "pasteHint": "Nous proposerons des entrées structurées. Rien n'est enregistré tant que vous n'avez pas validé.",
      "pasteCharCount": "{{count}} / {{max}} caractères (minimum {{min}})",
      "continue": "Continuer",
      "processing": "Lecture du document…",
      "reviewTitle": "Vérifier l'import",
      "reviewSummary": "{{faq}} FAQ · {{policies}} politiques · {{general}} champs généraux proposés",
      "reviewSummaryGeneral": "{{general}} champs généraux proposés",
      "reviewSummaryFaq": "{{faq}} FAQ proposées",
      "reviewSummaryPolicies": "{{policies}} politiques proposées",
      "warningsHeading": "Notes de l'import",
      "reviewEmpty": "Rien de nouveau à ajouter depuis ce document.",
      "addSelected": "Ajouter la sélection ({{count}})",
      "back": "Retour",
      "lowConfidence": "Faible confiance — vérifier avant d'appliquer",
      "conflictFaq": "FAQ similaire existante : {{question}}",
      "conflictPolicy": "Politique similaire existante : {{title}}",
      "faqCapBanner": "Seulement {{allowed}} FAQ sur {{selected}} peuvent être ajoutées (50 max par studio)",
      "successFaq": "{{count}} entrées FAQ ajoutées",
      "successPolicies": "{{entries}} politiques et {{overrides}} remplacements ajoutés",
      "successGeneral": "{{count}} champs généraux mis à jour",
      "successMixed": "Import appliqué avec succès",
      "applyPartial": "{{applied}} appliqué(s). {{failed}} n'ont pas pu être appliqués. Vérifiez les lignes indiquées.",
      "rowApplyFailed": "Cette entrée n'a pas pu être appliquée. Vérifiez la valeur et réessayez.",
      "selectProposal": "Sélectionner la proposition",
      "sourceExcerpt": "Extrait source",
      "policyOverrideLabel": "Appliquer comme remplacement pour {{section}}",
      "openingHoursStructured": "Les horaires structurés seront appliqués",
      "generalField": {
        "description": "Description",
        "address": "Adresse",
        "directions": "Itinéraire",
        "firstVisitInfo": "Infos première visite",
        "facilities": "Équipements",
        "openingHours": "Horaires d'ouverture",
        "phone": "Téléphone principal",
        "email": "E-mail principal",
        "website": "Site web",
        "mapsLink": "Lien Google Maps"
      },
      "upload": {
        "dropHint": "Glissez-déposez un fichier ou choisissez-en un",
        "chooseFile": "Choisir un fichier",
        "removeFile": "Retirer le fichier",
        "pasteInstead": "Coller le texte à la place",
        "extracting": "Extraction du texte…",
        "pdfDisclaimer": "L'extraction PDF peut omettre des tableaux ou des pages scannées. Vérifiez les propositions."
      },
      "errors": {
        "generic": "Échec de l'import. Réessayez.",
        "PREVIEW_EXPIRED": "Cet aperçu a expiré. Collez à nouveau votre texte.",
        "FAQ_LIMIT_REACHED": "Limite FAQ atteinte pour ce studio.",
        "POLICY_LIMIT_REACHED": "Limite de politiques atteinte pour ce studio.",
        "VALIDATION_ERROR": "Certaines entrées n'ont pas pu être appliquées.",
        "EXTRACTION_FAILED": "Impossible d'extraire le contenu.",
        "PREVIEW_TIMEOUT": "Traitement trop long. Essayez un document plus court.",
        "RATE_LIMITED": "Trop de tentatives. Veuillez patienter.",
        "RATE_LIMIT_EXCEEDED": "Trop de tentatives. Veuillez patienter.",
        "KNOWLEDGE_IMPORT_DISABLED": "Import temporairement indisponible.",
        "FILE_TOO_LARGE": "Fichier trop volumineux (max. 5 Mo).",
        "UNSUPPORTED_FILE_TYPE": "Type de fichier non pris en charge.",
        "EXTRACTION_EMPTY": "Aucun texte extrait de ce fichier.",
        "PASSWORD_PROTECTED_FILE": "Ce fichier est protégé par mot de passe."
      }
    },
    "addNewUnit": "Ajouter un nouveau studio",
    "archiveSuccess": "Studio archivé.",
    "archiveError": "Échec de l'archivage du studio.",
    "notConfiguredShort": "Connect",
    "noStudiosFound": "Aucun studio trouvé.",
    "noSearchMatch": "Aucun studio ne correspond à votre recherche.",
    "backToStudioList": "Retour à la liste des studios",
    "showStudioList": "Afficher la liste des studios",
    "expandDetailFullWidth": "Étendre les détails du studio à toute la largeur",
    "fullWidthTooltip": "Pleine largeur",
    "collapseDetailDefaultWidth": "Revenir à la largeur par défaut",
    "moreStudioActionsAria": "Plus d'actions en studio",
    "studioIdLabel": "ID du studio",
    "archiveMenuItem": "Archive",
    "archiveStudioTitle": "Archiver le studio",
    "archiveStudioConfirm": "Êtes-vous sûr(e) de vouloir archiver «<x id=\"1\"/>» ?",
    "dangerZone": "Zone dangereuse",
    "archiveStudioDangerBody": "Le studio sera déplacé vers Archive et masqué des listes de données Studio actives.",
    "archiveAnyway": "Archiver quand même",
    "sync": {
      "syncAll": "Synchroniser toutes les données",
      "syncPricing": "Synchroniser les tarifs",
      "syncClasses": "Synchroniser les cours",
      "syncSchedule": "Synchroniser le planning",
      "syncTeam": "Synchroniser l'équipe",
      "blockLabel": "Synchroniser {{block}}",
      "syncing": "Synchronisation…",
      "lastSynced": "Dernière synchronisation : {{time}}",
      "error": "Échec de la synchronisation. Veuillez réessayer.",
      "retry": "Réessayer"
    },
    "tabs": {
      "campaigns": {
        "intro": "Lorsqu'une personne vous écrit depuis une de vos publicités Instagram, l'assistant peut l'accueillir avec l'offre annoncée par cette publicité. Configurez vos campagnes ci-dessous.",
        "addCampaign": "Ajouter une campagne",
        "groupCurrent": "En cours",
        "groupPast": "Campagnes passées ({{count}})",
        "rowSummary": "{{packs}} formules · {{ads}} publicités",
        "allAdsWord": "toutes",
        "statusActiveChip": "Active · se termine le {{date}}",
        "statusEndingSoonChip": "Se termine bientôt · se termine le {{date}}",
        "statusScheduledChip": "Programmée · débute le {{date}}",
        "statusExpiredChip": "Expirée · terminée le {{date}}",
        "statusNotReadyChip": "Non prête",
        "versionConflict": "Cette campagne a été modifiée dans une autre session. Vérifiez la campagne actualisée et réessayez.",
        "readinessTitle": "Préparation",
        "readyChip": "Prête",
        "openAiBehaviour": "Ouvrir le comportement IA",
        "endDateMissingHelper": "Quand cette campagne publicitaire se termine-t-elle ? L'assistant arrête d'accueillir les nouveaux prospects après cette date, pour que vous n'ayez pas à penser à la désactiver.",
        "allAdsNote": "Chaque publicité recevra cette offre — ne choisissez cette option que si toutes vos publicités actuelles portent sur elle.",
        "toastCreateFailed": "Impossible de créer la campagne.",
        "toastSaveFailed": "Échec de l'enregistrement.",
        "loadError": "Impossible de charger les campagnes.",
        "loadErrorRetry": "Réessayer",
        "empty": {
          "title": "Aucune campagne pour le moment",
          "body": "Une campagne regroupe les publicités, les formules d'essai et les dates d'une offre. Ajoutez-en une pour commencer."
        },
        "missing": {
          "template": "Texte d'accueil : pas encore configuré par OktoGo",
          "packs": "Ajoutez au moins une formule",
          "pack_link": "Une formule n'a pas de lien d'achat",
          "eligible_ads": "Choisissez quelles publicités mènent ici",
          "valid_to": "Date de fin manquante",
          "ad_conflict": "Conflit de publicité"
        },
        "welcomeMessage": {
          "title": "Message de bienvenue",
          "hint": "Un seul message de bienvenue pour toutes les campagnes · le premier message que reçoit un nouveau prospect, avec les formules de cette campagne",
          "placeholder": "Rédigez le message qu'un nouveau prospect reçoit en premier…",
          "tabEdit": "Modifier",
          "tabPreview": "Aperçu",
          "tokenHint": "Conservez {{packs}} dans le texte — il est remplacé par les formules de cette campagne.",
          "counter": "{{current}} / {{max}}",
          "errorEmpty": "Le message de bienvenue ne peut pas être vide.",
          "errorMissingSlot": "Ajoutez {{packs}} à l'endroit où les formules de la campagne doivent apparaître.",
          "versionConflict": "Ce message de bienvenue a été modifié dans une autre session. Rechargez avant d'enregistrer.",
          "translationFailed": "Ce message de bienvenue n'a pas pu être traduit dans les autres langues, cette version n'est donc pas encore utilisée. Modifiez le texte et enregistrez à nouveau pour réessayer."
        },
        "addDialog": {
          "title": "Ajouter une campagne",
          "nameLabel": "Nom de la campagne",
          "namePlaceholder": "ex. Offre d'essai d'automne",
          "validFromLabel": "Débute le",
          "validToLabel": "Se termine le",
          "allAdsCheckbox": "Toutes mes publicités Instagram",
          "create": "Créer la campagne",
          "nameRequired": "Le nom de la campagne est requis.",
          "dateRangeInvalid": "La date de fin ne peut pas être antérieure à la date de début."
        },
        "packsCard": {
          "title": "Formules d'essai proposées aux prospects de la campagne",
          "addPack": "Ajouter une formule",
          "empty": "Aucune formule pour le moment. Ajoutez-en une pour proposer un essai aux prospects de la campagne.",
          "shopWide": "formule boutique",
          "linkFromEversports": "lien depuis Eversports",
          "linkPasted": "lien collé",
          "noLinkYet": "le cours n'a pas encore de lien de page",
          "priceDrift": "prix modifié sur Eversports"
        },
        "packPanel": {
          "titleNew": "Nouvelle formule",
          "nameLabel": "Nom de la formule",
          "namePlaceholder": "ex. Formule d'essai 2+1 20 min",
          "nameRequired": "Le nom de la formule est requis.",
          "priceLabel": "Prix",
          "currencyLabel": "Devise",
          "conditionsLabel": "Conditions (facultatif)",
          "conditionsPlaceholder": "ex. 3 cours encadrés de bain glacé de 20 minutes sur 3 mois",
          "linkedClassSectionTitle": "Cours associé",
          "pricingOptionsTitle": "Options tarifaires (ce cours, depuis Eversports)",
          "pricingOptionsEmpty": "Aucune option tarifaire synchronisée pour ce cours pour l'instant.",
          "purchaseLinkLabel": "Lien d'achat",
          "purchaseLinkPlaceholder": "https://www.eversports.at/e/…",
          "fromEversports": "depuis Eversports",
          "pasteALink": "Coller un lien",
          "syncClassesAndPricing": "Synchroniser cours et tarifs",
          "readinessMissingLink": "⚠ Ce cours n'a pas encore de lien de page.",
          "linkHostWarning": "Ceci ne ressemble pas à un lien Eversports. Les formules de campagne sont généralement vendues sur votre page Tarifs Eversports.",
          "priceDriftWarning": "Le prix de la formule a changé sur Eversports — à vérifier (synchronisé {{synced}})",
          "deleteTitle": "Supprimer la formule ?",
          "deleteDescription": "Cette action est irréversible.",
          "delete": "Supprimer"
        },
        "classPicker": {
          "linkToClass": "Associer à un cours",
          "shopWidePack": "Formule boutique — aucun cours spécifique",
          "searchPlaceholder": "Rechercher parmi vos cours…",
          "loading": "Chargement de vos cours…",
          "noMatch": "Aucun cours correspondant.",
          "addManually": "Introuvable ? → Ajouter le cours manuellement",
          "hasPage": "● page",
          "noPage": "○ pas de page",
          "changeClass": "Changer de cours",
          "manualNote": "saisi manuellement — non synchronisé",
          "manual": {
            "nameLabel": "Nom du cours",
            "namePlaceholder": "ex. Pure Ice Bath",
            "linkLabel": "Lien du cours (page cours Eversports)",
            "linkPlaceholder": "https://www.eversports.at/e/…",
            "helper": "Ouvrez le cours sur Eversports et collez l'adresse de sa page (…/e/… ou …/activity/…)."
          }
        },
        "adsCard": {
          "title": "Quelles publicités mènent ici",
          "radioListed": "Uniquement les publicités listées ci-dessous",
          "radioAll": "Toutes mes publicités Instagram",
          "addAd": "Ajouter une publicité",
          "adIdLabel": "ID de publicité Meta",
          "adIdHelpAria": "Qu'est-ce que l'ID de publicité Meta ?",
          "adIdTooltipWhy": "C'est ainsi que nous reconnaissons les personnes qui viennent de cette publicité, afin qu'elles reçoivent le message d'accueil de cette campagne.",
          "adIdTooltipWhere": "Copiez l'ID de la publicité depuis la colonne « ID de la publicité » dans Meta Ads Manager — ou collez directement le lien Ads Manager de la publicité dans ce champ.",
          "adIdPlaceholder": "ex. 120212345678901234",
          "labelOptional": "Libellé (facultatif)",
          "labelPlaceholder": "ex. Publicité d'essai d'été",
          "empty": "Aucune publicité listée pour l'instant.",
          "delete": "Retirer la publicité",
          "edit": "Modifier la publicité",
          "formatError": "Indiquez le numéro de la publicité, ou collez le lien Meta Ads Manager de la publicité.",
          "campaignLinkError": "Ce lien pointe vers une campagne, pas vers une publicité unique. Ouvrez la publicité elle-même dans Ads Manager et collez ce lien.",
          "adsetLinkError": "Ce lien pointe vers un ensemble de publicités, pas vers une publicité unique. Ouvrez la publicité elle-même dans Ads Manager et collez ce lien.",
          "multipleAdsError": "Ce lien contient plusieurs publicités. Veuillez ajouter une publicité à la fois.",
          "duplicateError": "Cet ID de publicité est déjà listé.",
          "conflictError": "Déjà utilisé par « {{name}} » (jusqu'au {{date}}).",
          "conflictErrorOpenEnded": "Cette publicité est réservée par « {{name}} » sans date de fin. Définissez une date de fin pour cette campagne.",
          "wildcardConflictErrorOpenEnded": "Toutes les publicités sont réservées par « {{name}} » sans date de fin. Définissez une date de fin pour cette campagne.",
          "wildcardConflictError": "« {{name}} » revendique déjà toutes les publicités sur une période qui se chevauche (jusqu'au {{date}}).",
          "helperTitle": "Comment trouver l'ID de publicité Meta ?",
          "helperStep1": "Ouvrez le Gestionnaire de publicités Meta → onglet Publicités.",
          "helperStep2": "Ajoutez la colonne « ID de la publicité » (Colonnes → Personnaliser) — ou ouvrez la publicité et collez ici son adresse complète ; nous trouverons le numéro après « selected_ad_ids= ».",
          "helperStep3": "Collez le numéro ici — ou collez le lien Ads Manager de la publicité, nous en extrairons le numéro.",
          "learnMore": "En savoir plus",
          "notSureHint": "Pas sûr ? Choisissez « Toutes mes publicités Instagram » pour l'instant — vous pourrez affiner plus tard."
        }
      },
      "faq": {
        "saving": "Enregistrement…",
        "saved": "Enregistré",
        "addFaq": "Ajouter une FAQ",
        "readOnly": "Lecture seule",
        "questionPlaceholder": "Question",
        "answerPlaceholder": "Réponse",
        "deleteTitle": "Supprimer la FAQ",
        "deleteDescription": "Cette action ne peut pas être annulée.",
        "delete": "Effacer",
        "empty": "Pas encore de FAQ. Ajoutez votre première FAQ ci-dessus.",
        "toastAdded": "QFP a ajouté.",
        "toastAddFailed": "Échec de l’ajout",
        "toastUpdated": "FAQ mise à jour.",
        "toastUpdateFailed": "Échec de la mise à jour.",
        "toastDeleted": "FAQ supprimée.",
        "toastDeleteFailed": "Échec de la suppression."
      },
      "general": {
        "openingHours": "Heures d’ouverture",
        "closed": "Fermé",
        "location": "Emplacement",
        "description": "Description",
        "descriptionPlaceholder": "Bref aperçu pour les clients et l’IA—offre, ambiance et détails pratiques comme le parking.",
        "address": "Adresse",
        "addressPlaceholder": "ex. 42 rue Principale, 75001 Paris",
        "addressInvalid": "Saisissez une adresse avec des lettres, un chiffre et un espace ou une virgule.",
        "timezone": "Fuseau horaire du studio",
        "timezonePlaceholder": "ex. Europe/Paris",
        "timezoneHelper": "Utilisé pour les horaires et les actions sensibles au temps de ce studio.",
        "timezoneInvalid": "Saisissez un fuseau horaire IANA valide, par exemple Europe/Paris.",
        "hoursRequired": "Indiquez une heure d'ouverture et de fermeture pour {{day}}, ou marquez ce jour comme fermé.",
        "hoursOutOfOrder": "L'heure de fermeture pour {{day}} doit être postérieure à l'heure d'ouverture.",
        "mapsLink": "Lien au Google Maps :",
        "mapsLinkPlaceholder": "https://maps.google.com/…",
        "mapsLinkInvalid": "Saisissez un lien Google Maps.",
        "directions": "Instructions",
        "directionsPlaceholder": "Comment vous trouver—entrée, étage, transports, parking ou autres conseils d’arrivée.",
        "contacts": "Contact",
        "phone": "Téléphone principal",
        "phonePlaceholder": "+33 1 23 45 67 89",
        "phoneInvalid": "Saisissez un numéro de téléphone d’au moins 6 chiffres. Chiffres et ponctuation standard uniquement.",
        "email": "E-mail principal",
        "emailPlaceholder": "bonjour@votrestudio.fr",
        "emailInvalid": "Saisissez une adresse e-mail valide.",
        "website": "Site web",
        "websitePlaceholder": "votrestudio.fr",
        "facilities": "Infrastructures",
        "facilityPlaceholder": "Ajouter une commodité",
        "add": "Ajouter",
        "firstVisit": "Infos première visite",
        "firstVisitLinks": {
          "trialRegistrationLabel": "Lien d'inscription essai (Scénario 1)",
          "trialRegistrationPlaceholder": "votrestudio.fr/inscription-essai",
          "trialRegistrationHelper": "Utilisé quand le client n'a pas encore de compte sur la plateforme de réservation.",
          "studioLabel": "Page Eversports du studio (Scénario 2)",
          "studioPlaceholder": "www.eversports.com/s/votre-studio",
          "studioHelper": "Utilisé quand le client a un compte Eversports mais est nouveau dans votre studio. Préférez Overview ci-dessous pour les infos générales.",
          "overviewLabel": "Page Aperçu",
          "overviewPlaceholder": "www.eversports.com/s/votre-studio",
          "overviewHelper": "Section Aperçu publique (à propos, adresse, équipements). Pour les questions générales sur le studio.",
          "classesLabel": "Calendrier des cours",
          "classesPlaceholder": "www.eversports.com/scl/votre-studio",
          "classesHelper": "Calendrier public de la semaine. Quand les clients demandent le planning ou comment réserver.",
          "pricesLabel": "Page Tarifs",
          "pricesPlaceholder": "www.eversports.com/sp/votre-studio",
          "pricesHelper": "Catalogue public des tarifs / produits. Pour les abonnements et prix des produits.",
          "urlInvalid": "Ajoutez l’adresse du site, par exemple rowinc.studio."
        },
        "firstVisitPlaceholder": "Ce que les nouveaux clients doivent savoir avant leur première visite—arrivée, à prévoir, enregistrement et règles du studio.",
        "saveChanges": "Enregistrer les modifications",
        "toastSaved": "Modifications enregistrées.",
        "toastSaveFailed": "Échec de l’enregistrement. ",
        "weekday": {
          "monday": "Lundi",
          "tuesday": "Mardi",
          "wednesday": "Mercredi",
          "thursday": "Jeudi",
          "friday": "Vendredi",
          "saturday": "Samedi",
          "sunday": "Dimanche"
        }
      },
      "generalPublic": {
        "heading": "Infos publiques du studio",
        "syncLabel": "Synchroniser Général",
        "syncCaption": "La synchronisation Général actualise ensemble votre « À propos » public, les équipements, Instagram et la note.",
        "previewCaption": "Données d’aperçu — pas de données de studio réellement synchronisées",
        "empty": "Pas encore synchronisé. Cliquez sur « Synchroniser Général » pour prévisualiser un exemple d’infos publiques.",
        "aboutHeading": "À propos",
        "amenitiesHeading": "Équipements",
        "amenityOffered": "Proposé",
        "amenityNotOffered": "Non proposé",
        "amenityUnknown": "Pas encore synchronisé",
        "ratingLabel": "{{value}} ({{count}} avis)"
      },
      "policies": {
        "toastSaved": "Remplacement de la politique enregistré.",
        "toastSaveFailed": "Échec de l’enregistrement. ",
        "toastAdded": "Politique ajoutée.",
        "toastAddFailed": "Échec de l’ajout de la politique.",
        "toastUpdated": "Politique mise à jour.",
        "toastUpdateFailed": "Échec de la mise à jour de la politique.",
        "toastDeleted": "Politique supprimée.",
        "toastDeleteFailed": "Échec de la suppression de la politique.",
        "syncedFrom": "Synchronisé à partir de {{source}}",
        "bookingPlatformFallback": "Plateforme de réservation",
        "manualEntriesTitle": "Politiques personnalisées",
        "addPolicy": "Ajouter une politique",
        "policyTitlePlaceholder": "Titre de la politique",
        "policyContentPlaceholder": "Saisissez les détails de la politique…",
        "manualEntriesEmpty": "Aucune politique personnalisée pour le moment.",
        "deleteTitle": "Supprimer la politique ?",
        "deleteDescription": "Cette entrée de politique sera supprimée.",
        "delete": "Supprimer",
        "ownerOverride": "Remplacement du propriétaire",
        "overridePlaceholder": "Entrez votre propre texte de politique pour remplacer la version synchronisée…",
        "saveOverride": "Enregistrer le remplacement",
        "overrideActive": "Remplacement du propriétaire (actif)",
        "refundIfCancelledAtLeast": "Remboursement si annulé au moins",
        "beforeClassStart": "avant le début du cours",
        "hoursBeforeClassStart": "heures avant le début du cours",
        "hoursPreset": "{{count}} heures",
        "hoursCustom": "Personnalisé…",
        "toastInvalidHours": "Saisissez un nombre entier d’heures entre 1 et 168.",
        "customHoursAria": "Heures personnalisées",
        "hoursInfoAria": "En savoir plus sur cette règle",
        "hoursInfoTitle": "À propos de ce nombre",
        "hoursInfoCredit": "Crédit de cours ou pass rendu — pas un remboursement bancaire.",
        "hoursInfoMove": "Les mêmes heures s’appliquent s’ils demandent à déplacer ce cours.",
        "hoursInfoNumberBeatsNotes": "Copilot suit ce nombre, pas les notes ci-dessous.",
        "hoursPreview": "Les clients qui annulent {{hours}} heures ou plus avant le début du cours peuvent récupérer un crédit de cours ou leur pass. Plus tard : ils peuvent encore annuler ou déplacer, sans crédit.",
        "additionalNotes": "Notes d’annulation supplémentaires (facultatif)",
        "additionalNotesHint": "Exceptions, maladie, préavis d’abonnement — Copilot peut les expliquer. Elles ne changent pas les heures ci-dessus.",
        "additionalNotesPlaceholder": "Saisissez des notes de politique supplémentaires…",
        "saveAdditionalNotes": "Enregistrer",
        "additionalNotesActive": "Notes supplémentaires",
        "empty": "Aucune section de politique pour le moment. Connectez une plateforme de réservation pour synchroniser le texte des politiques.",
        "syncCancellationPolicy": "Synchroniser la politique d'annulation",
        "syncRefundPolicy": "Synchroniser la politique de remboursement",
        "cancellationPolicyEmpty": "Pas encore publié publiquement — rien n'est inventé. Cliquez sur « Synchroniser la politique d'annulation » pour vérifier à nouveau.",
        "refundPolicyEmpty": "Pas encore publié publiquement — rien n'est inventé. Cliquez sur « Synchroniser la politique de remboursement » pour vérifier à nouveau.",
        "refundPolicyPreviewLine": "Données d'aperçu — pas un texte de politique réellement importé : « Remboursement intégral jusqu'à 24 heures avant le début du cours ; crédit de cours ensuite. »"
      },
      "prices": {
        "syncCaption": "La synchronisation des tarifs actualise cet onglet et les options tarifaires de chaque cours ensemble.",
        "previewCaption": "Données d’aperçu — pas les tarifs Eversports en direct",
        "membershipsHeading": "Abonnements",
        "membershipsEmpty": "Pas encore synchronisé. Cliquez sur « Synchroniser les tarifs » pour prévisualiser des exemples d’abonnements.",
        "productsHeading": "Produits",
        "productsEmpty": "Pas encore synchronisé. Cliquez sur « Synchroniser les tarifs » pour prévisualiser des exemples de produits.",
        "minRuntime_one": "{{count}} mois minimum",
        "minRuntime_other": "{{count}} mois minimum"
      },
      "team": {
        "syncCaption": "La synchronisation de l'équipe actualise cet onglet avec l'annuaire des instructeurs de votre page Eversports publique.",
        "previewCaption": "Données d'aperçu — pas un véritable annuaire d'instructeurs",
        "heading": "Instructeurs",
        "empty": "Pas encore synchronisé. Cliquez sur « Synchroniser l'équipe » pour prévisualiser des exemples d'instructeurs.",
        "viewSchedule": "Voir le planning"
      },
      "users": {
        "selectStudio": "Sélectionnez un studio pour gérer les utilisateurs.",
        "peopleWithAccessLead": "Personnes ayant accès à",
        "peopleWithAccessTrail": ".",
        "thisStudio": "ce studio",
        "addMember": "Ajouter un membre",
        "inviteTitle": "Inviter un membre de l'équipe",
        "email": "E-mail",
        "managerInviteShort": "Les responsables ne peuvent inviter que le personnel.",
        "sendInvitation": "Envoyer l'invitation",
        "revokeHintAddMember": "Vous pourrez envoyer une nouvelle invitation plus tard depuis « Ajouter un membre » si vous changez d’avis.",
        "emptyTeam": "Aucun membre d’équipe ni invitation en attente pour le moment."
      },
      "sidePanel": {
        "title": "Ajouter un studio",
        "studioName": "Nom du studio",
        "namePlaceholder": "Saisir le nom du studio",
        "nameRequired": "Le nom du studio est obligatoire.",
        "nameTooShort": "Le nom du studio doit contenir au moins 2 caractères.",
        "nameTooLong": "Le nom du studio doit contenir au plus 60 caractères.",
        "nameAlreadyExists": "Ce nom de studio existe déjà.",
        "nameArchivedConflict": "Ce nom correspond à un studio archivé. Restaurez ou renommez d’abord le studio archivé.",
        "studioLimitReached": "Maximum 5 studios actifs. Archivez un studio avant d’en créer un autre.",
        "description": "Description",
        "descriptionPlaceholder": "Saisir la description du studio",
        "descriptionTooLong": "La description doit contenir au plus 200 caractères.",
        "descriptionCharCount": "{{current}}/{{max}}",
        "teamMembers": "Membres de l'équipe",
        "teamHint": "Invitez des personnes après la création du studio, ou saisissez nom et e-mails ci-dessous pour inviter automatiquement.",
        "memberNamePlaceholder": "Nom complet",
        "memberNameRequired": "Le nom est obligatoire.",
        "memberNameAria": "Nom de l’invité",
        "memberEmailAria": "E-mail de l’invité",
        "emailPlaceholder": "email@exemple.com",
        "emailRequired": "L’e-mail est obligatoire.",
        "emailInvalid": "Saisissez une adresse e-mail valide.",
        "emailDuplicate": "Cet e-mail est déjà dans la liste.",
        "addMemberButtonAria": "Ajouter le membre à la liste",
        "editMemberAria": "Modifier le membre de l’équipe",
        "saveMemberEdit": "Enregistrer le membre",
        "finishEditingFirst": "Enregistrez ou annulez vos modifications avant de créer le studio.",
        "removeAria": "Retirer",
        "cancel": "Annuler",
        "create": "Créer le studio",
        "toastInvalidEmail": "Saisissez une adresse e-mail valide.",
        "toastDuplicateEmail": "Cet e-mail est déjà dans la liste.",
        "toastCreateFailed": "Échec de la création du studio.",
        "toastInviteFailed": "L'invitation à {{email}} n'a pas pu être envoyée.",
        "toastCreated": "Studio créé.",
        "toastGrantFailedExisting": "Impossible d'accorder l'accès à {{email}} pour ce studio.",
        "toastGrantAlreadyMemberExisting": "{{email}} est déjà membre de ce nouveau studio."
      },
      "trace": {
        "panelTitle": "Trace agent vision",
        "closeAria": "Fermer",
        "enterFullscreenAria": "Agrandir en plein écran",
        "exitFullscreenAria": "Quitter le plein écran",
        "backToClasses": "Retour aux cours",
        "pageTitle": "Trace agent vision",
        "pageSubtitle": "Choisissez une exécution récente dans la liste (audit ClickHouse) ou collez un ID d'exécution. S3 est requis pour les captures et les téléchargements d'artefacts.",
        "selectStudioForTraces": "Sélectionnez un studio pour charger les traces.",
        "recentRuns": "Exécutions récentes de l'agent",
        "window": "Fenêtre",
        "daysOption": "{{count}} jours",
        "refresh": "Actualiser",
        "clickHouseNoList": "Aucune exécution d'agent sur cette période. L'audit ClickHouse n'est pas configuré : cette liste provient du journal d'audit Postgres local. Utilisez « ID d'exécution » ci-dessous si vous avez un UUID.",
        "loadingRuns": "Chargement des exécutions…",
        "lastActivity": "Dernière activité",
        "platform": "Plateforme",
        "lastEvent": "Dernier événement",
        "events": "Événements",
        "estimatedLlmCostColumn": "Coût LLM estimé",
        "runsListTotalEstimatedLlmCost": "Total des exécutions affichées (LLM estimé) : {{amount}}",
        "runsListCostDisclaimer": "Montants estimés dans l’app à partir de l’usage de tokens (heuristiques prix catalogue), pas des factures.",
        "runIdLabel": "ID d'exécution (facultatif)",
        "runIdSrOnly": "ID d'exécution de l'agent",
        "runIdPlaceholder": "Coller l'UUID s'il n'est pas dans la liste ci-dessus",
        "loadTrace": "Charger la trace",
        "loadError": "Impossible de charger la trace.",
        "syncComplete": "Synchronisation terminée",
        "syncFailed": "Échec de la synchronisation",
        "runLoaded": "Exécution chargée",
        "linkPlaywrightTrace": "Trace Playwright",
        "linkRecording": "Enregistrement",
        "linkHar": "HAR",
        "linkLlmDecisions": "Décisions LLM",
        "latestStepAlt": "Dernière étape",
        "classesSynced": "{{count}} cours synchronisés",
        "percentComplete": "100 %",
        "llmTotalLabel": "Total LLM :",
        "llmCallsCount": "({{count}} appels)",
        "failureHeading": "Capture d'échec",
        "failureAlt": "Échec",
        "s3NotConfigured": "Les traces agent S3 ne sont pas configurées sur ce serveur ; captures et téléchargements indisponibles.",
        "durationMs": "{{n}} ms",
        "durationSeconds": "{{n}} s",
        "runDurationSuffix": " · {{n}} s",
        "tokensSummary": "{{input}} entrée / {{output}} sortie ({{total}} jetons)",
        "orchestratorTraceHeading": "Trace orchestrateur chat",
        "intent": "Intention",
        "confidence": "Confiance",
        "decisionOrigin": "Décision",
        "groundingVerdict": "Ancrage",
        "escalationReason": "Escalade",
        "toolsCalled": "Outils",
        "toolOutcome": "Résultat de l'outil",
        "ragChunks": "RAG",
        "decisionSteps": "Étapes de décision",
        "llmTemperature": "temp {{value}}",
        "llmMaxTokens": "max {{value}} jetons",
        "expandDetails": "Détails",
        "collapseDetails": "Masquer",
        "executionRoute": "Route",
        "interactionMode": "Mode",
        "subFlow": "Sous-flux",
        "method": "Méthode",
        "selfHealed": "Auto-réparé",
        "systemPrompt": "Système",
        "userPrompt": "Utilisateur",
        "llmResponse": "Réponse",
        "llmPromptKey": "Prompt",
        "llmPromptSummary": "Structure",
        "llmReasoning": "Raisonnement",
        "promptKind": "Type",
        "workflowLiveBadge": "Live",
        "workflowReplayBadge": "Relecture",
        "workflowTopologyTitle": "Topologie du workflow",
        "workflowEventsCount": "{{count}} événements en direct",
        "cascadeOf": "Cascade après l’échec initial {{rootCauseId}}",
        "technicalDetails": "Détails techniques",
        "openConversation": "Ouvrir la conversation",
        "privacyHiddenContent": "(contenu masqué pour la confidentialité)",
        "tier": {
          "decisionLabel": "Décision de palier",
          "name": {
            "json_feed": "Flux JSON",
            "dom_text_early": "Texte DOM (précoce)",
            "dom_script": "Script DOM",
            "cli_playwright": "CLI Playwright",
            "mcp_text": "Texte MCP",
            "vision_agent": "Agent vision"
          },
          "outcome": {
            "success": "Succès",
            "fail": "Échec",
            "skip": "Ignoré"
          },
          "reason": {
            "skip_anonymous_or_non_schedule": "Ignoré (anonyme / hors planning)",
            "skip_dom_not_applicable": "Ignoré (DOM non applicable)",
            "disabled_by_config": "Désactivé par configuration",
            "consecutive_failures": "Échecs consécutifs",
            "llm_last_resort_enabled": "LLM en dernier recours actif",
            "range_mismatch": "Plage de dates incohérente",
            "empty_feed": "Flux vide",
            "tier_timeout": "Délai de palier dépassé",
            "tier_error": "Erreur de palier",
            "selector_not_found": "Sélecteur introuvable",
            "initial_navigation_failed": "Navigation initiale échouée",
            "auth_retry_limit": "Limite de tentatives d’authentification atteinte",
            "reauth_failed": "Ré-authentification échouée",
            "no_meaningful_result": "Aucun résultat exploitable"
          }
        }
      },
      "classes": {
        "weekdayMon": "lun",
        "weekdayTue": "mar",
        "weekdayWed": "mer",
        "weekdayThu": "jeu",
        "weekdayFri": "ven",
        "weekdaySat": "sam",
        "weekdaySun": "dim",
        "viewList": "Liste",
        "viewCalendar": "Calendrier",
        "syncComplete": "Synchronisation terminée",
        "syncFailed": "Échec de la synchronisation",
        "syncing": "Synchronisation…",
        "viewTrace": "Voir la trace",
        "latestStepAlt": "Dernière étape",
        "agentScreenshots": "Captures de l'agent ({{count}})",
        "stepLabel": "Étape {{n}}",
        "tableClass": "Cours",
        "tableInstructor": "Coach",
        "tableTime": "Heure",
        "tableDuration": "Durée",
        "tableLevel": "Niveau",
        "tableSpots": "Places au prochain cours",
        "minutes": "{{n}} min",
        "spotsLeft": "{{n}} restantes",
        "full": "Complet",
        "emptyList": "Aucun cours synchronisé pour le moment. Connectez une plateforme de réservation et lancez une synchronisation.",
        "detailStudio": "Studio",
        "detailLocation": "Lieu",
        "detailTrainer": "Coach",
        "detailTime": "Heure",
        "detailCapacity": "Capacité",
        "detailDuration": "Durée",
        "about": "À propos",
        "descriptionEmpty": "Aucune description de cours synchronisée pour le moment.",
        "pricingOptions": "Options réservables de ce cours",
        "pricingOptionsEmpty": "Options tarifaires pas encore disponibles. Copilot n'inventera pas de prix.",
        "links": "Liens",
        "classPageLink": "Ouvrir la page du cours",
        "bookingLink": "Ouvrir le lien de réservation",
        "bookSlot": "Réserver",
        "clients": "Clients ({{count}})",
        "bookingConfirmed": "Confirmé",
        "bookingWaitlisted": "Liste d'attente",
        "bookingCancelled": "Annulé",
        "bookingCheckedIn": "Présent",
        "upcomingSchedule": "Planning à venir",
        "noUpcomingSessions": "Aucune séance à venir sur cette période.",
        "showNextMonth": "Mois suivant",
        "showNextMonthAria": "Afficher le mois suivant",
        "loading": "Chargement…",
        "toastSyncComplete": "Synchronisation réussie.",
        "toastSyncFailed": "Échec de la synchronisation.",
        "toastSyncBookingPlatformNotConfigured": "Connectez une plateforme de réservation (Eversports, Mindbody ou Bsport) avant de synchroniser.",
        "syncLogInit": "Démarrage de la synchronisation pour {{start}} → {{end}}…",
        "syncLogStarted": "Tâche de synchronisation démarrée sur le serveur",
        "syncLogScreenshots": "{{count}} captures de l'agent chargées",
        "syncLogCompleted": "Synchronisation terminée",
        "syncLogFailedMsg": "Échec de la synchronisation",
        "syncStartError": "Impossible de démarrer la synchronisation"
      }
    }
  },
  "studioDataFilter": {
    "filter": "Filtre",
    "clearAll": "Effacer tout",
    "panelTitle": "Filtre",
    "panelDescription": "Narrow the studio list by integrations, booking source, and location.",
    "closeSheetAria": "Fermer",
    "sheetAriaLabel": "Filter studios",
    "channelConnection": "{{channel}} — connection",
    "sectionBookingSource": "Booking source",
    "sectionLocation": "Location (city, country)",
    "channelInstagram": "Instagram",
    "channelWhatsapp": "WhatsApp",
    "channelBooking": "Réservation",
    "tagChannelStatus": "{{channel}}: {{status}}",
    "tagSource": "Source: {{source}}",
    "connectionStatus": {
      "connected": "Connected",
      "error": "Error",
      "not_connected": "Not connected"
    },
    "bookingSource": {
      "eversports": "Eversports",
      "mindbody": "Mindbody",
      "bsport": "Bsport",
      "none": "None",
      "other": "D’autres"
    }
  },
  "team": {
    "selectStudioHint": "Select a studio in the header switcher to view the team list, remove members, and use Invite again for pending invites.",
    "aggregateListHint": "Les membres et les invitations en attente sont listés pour chaque studio auquel vous avez accès. Retirer et renvoyer s’appliquent au studio indiqué sur chaque ligne.",
    "inviteMember": "Invite Team Member",
    "studiosMultiLabel": "Studios (select one or more)",
    "studioSingleLabel": "Studio",
    "noStudiosForInvite": "No studios are available for invitations with your account.",
    "includeStudioAria": "Include {{name}}",
    "emailAddress": "Email address",
    "inviteNamePlaceholder": "Entrez le nom",
    "emailPlaceholder": "team@studio.com",
    "role": "Role",
    "roleManager": "Manager",
    "roleStaff": "Staff",
    "managerInviteHint": "Managers can invite Staff only (per studio access you manage).",
    "accessPreview": "They will get access to {{studios}} as {{role}}.",
    "roleOwner": "Owner",
    "sendInvitation": "Send Invitation",
    "colName": "Name",
    "pendingInviteNoName": "—",
    "pendingInviteNameSr": "Invitation en attente pour {{email}}",
    "emailInvalid": "Saisissez une adresse e-mail valide.",
    "colStudio": "Studio",
    "colEmail": "E-mail",
    "colRole": "Role",
    "colStatus": "Statut",
    "colActions": "Actions",
    "statusActive": "Active",
    "statusPending": "Pending",
    "ownerCannotRemove": "Studio owners cannot be removed here",
    "inviteAgain": "Invite again",
    "inviteToOtherStudios": "Inviter à d'autres studios",
    "editAccess": "Modifier l'accès",
    "editAccessLoadingStudios": "Chargement des studios où ce membre a accès…",
    "editAccessPerStudioHint": "Choisissez un rôle pour chaque studio. Seuls les studios que vous pouvez gérer sont listés.",
    "editAccessNothingChanged": "Aucune modification à enregistrer.",
    "editAccessStudioRoleAria": "{{studio}} — rôle",
    "editAccessMemberDetail": "{{name}} · {{email}}",
    "removeMemberMultiHint": "Choisissez chaque studio dont vous voulez retirer cette personne. Les studios non cochés conservent l'accès.",
    "removeMemberLoadingScope": "Vérification des studios…",
    "removeMemberStudioToggleAria": "Retirer de {{name}}",
    "removeMemberPickOneStudio": "Sélectionnez au moins un studio.",
    "toastMemberRemovedMulti": "Retiré de {{count}} studios.",
    "toastRemovePartialFail": "Impossible de retirer de : {{studios}}. Réessayez pour ces studios.",
    "resendInvitation": "Renvoyer l'invitation",
    "editPendingInviteAria": "Modifier l'invitation en attente pour {{email}}",
    "editPendingInviteTitle": "Modifier l'invitation en attente",
    "editPendingInviteSave": "Enregistrer les modifications",
    "toastInviteUpdated": "Invitation mise à jour.",
    "toastAccessUpdated": "Accès du membre mis à jour.",
    "toastEditAccessPartialFail": "Impossible de mettre à jour l'accès pour : {{studios}}. Réessayez pour ces studios.",
    "toastInviteUpdatePartial": "Ancienne invitation révoquée, mais le renvoi a échoué. Utilisez « Ajouter un membre » pour inviter à nouveau.",
    "removeMemberAria": "Remove {{name}} from studio",
    "revokeInviteAria": "Revoke invitation",
    "removeMemberTitle": "Remove team member",
    "removeMemberBody": "Are you sure you want to remove this person from the studio?",
    "removeMemberDetail": "{{name}} ({{email}}) will lose access to this studio immediately.",
    "removeMemberDetailStudio": "{{name}} ({{email}}) perdra immédiatement l’accès à {{studio}}.",
    "dangerIrreversible": "This action is irreversible from here. Their OktoGo account is not deleted; you can invite them again later if needed.",
    "removeAnyway": "Remove anyway",
    "revokeTitle": "Revoke invitation",
    "revokeBody": "The pending invite to {{email}} will be cancelled. They will not be able to join with the current link.",
    "revokeHint": "You can send a new invitation later from Invite Team Member if you change your mind.",
    "revoke": "Revoke",
    "toastInviteSent": "Invitation sent.",
    "toastInviteFailed": "Failed to send invitation.",
    "toastAlreadyMember": "{{email}} est déjà membre de ce studio. Ouvrez la liste de l'équipe ci-dessous pour gérer son rôle.",
    "toastAlreadyMemberMulti": "{{email}} est déjà membre de l'un des studios sélectionnés. Décochez-le et réessayez.",
    "addMemberSearchPlaceholder": "Ajouter par nom ou e-mail",
    "addMemberSearchHint": "Choisissez une personne de vos studios, ou tapez un nouvel e-mail pour l'inviter.",
    "candidateSearching": "Recherche…",
    "candidateNoMatches": "Aucun coéquipier correspondant dans vos studios.",
    "candidateNoMatchHelp": "Nous ne connaissons pas encore cet e-mail — nous enverrons une invitation.",
    "candidateAlreadyMemberBadge": "Déjà membre",
    "candidateChange": "Changer",
    "candidateAlreadyInLabel": "Déjà dans : {{studios}}",
    "refineSearch": "Affinez votre recherche.",
    "candidateAlreadyMemberHere": "{{name}} est déjà membre de ce studio.",
    "grantAccessTitle": "Accorder l'accès",
    "grantAccessButton": "Accorder l'accès",
    "grantAccessNotice": "{{name}} verra cet accès à la prochaine ouverture d'OktoGo.",
    "toastGrantSuccess": "Accès accordé à {{name}}.",
    "toastGrantFailed": "Impossible d'accorder l'accès.",
    "toastMemberRemoved": "Member removed from this studio.",
    "toastRemoveFailed": "Failed to remove member.",
    "toastResent": "Invitation sent again.",
    "toastResendFailed": "Failed to resend.",
    "toastResendRateLimited": "L'invitation vient d'être renvoyée. Réessayez dans quelques minutes.",
    "toastRevoked": "Invitation revoked.",
    "toastRevokeFailed": "Failed to revoke.",
    "candidateSelectBeforeInvite": "{{email}} appartient déjà à un utilisateur existant. Sélectionnez cet utilisateur dans la liste pour accorder l’accès."
  },
  "connections": {
    "addChannel": "Add Channel",
    "addBookingPlatform": "Ajouter une plateforme de réservation",
    "mockModeBanner": "Mode simulation — les canaux sont simulés, aucune connexion Meta ou plateforme de réservation réelle.",
    "mockReconnectHint": "En mode simulation : utilisez Reconnecter pour actualiser l’état WhatsApp simulé.",
    "errors": {
      "connectionIssue": "Problème de connexion",
      "activationRequired": "Activation WhatsApp requise — saisissez votre code PIN à 6 chiffres dans les Paramètres"
    },
    "colChannel": "Channel",
    "colIdentifier": "Identifier",
    "colAppliesTo": "S’applique à",
    "colStatus": "Statut",
    "colActions": "Actions",
    "statusConnected": "Connected",
    "statusError": "Error",
    "statusSkipped": "Skipped",
    "statusNotConnected": "Not connected",
    "connectedSince": "Connected since {{date}}",
    "connectedSinceLabel": "Connecté depuis",
    "lastSynced": "Last synced: {{time}}",
    "configure2fa": "Configure 2FA",
    "reconnect": "Reconnect",
    "connect": "Connect",
    "emptyChannels": "No channels configured. Add one to get started.",
    "modalAddTitle": "Add Channel",
    "channelType": "Channel Type",
    "addChannelTenantScopeHint": "Les canaux de messagerie s'appliquent à tous les studios de votre compte. Vous n'assignez pas un canal à un seul studio.",
    "addChannelSubmit": "Add Channel",
    "bookingReconnectTitle": "Reconnect Booking Platform",
    "bookingConnectTitle": "Connect Booking Platform",
    "bookingTenantScopeHint": "Les identifiants de la plateforme de réservation s'appliquent à tous les studios de votre compte. Vous ne limitez pas cette intégration à un seul studio.",
    "twoFaTenantScopeHint": "L'authentification à deux facteurs pour la réservation s'applique au niveau du compte pour Eversports et couvre tous les studios qui utilisent cette connexion.",
    "platformLabel": "Platform",
    "bookingPlatformLabel": "Booking Platform",
    "selectPlatformPlaceholder": "Select your platform",
    "usernameEmail": "Username / Email",
    "usernamePlaceholder": "you@studio.com",
    "password": "Mot de passe",
    "passwordPlaceholder": "••••••••",
    "updateCredentials": "Update credentials",
    "twoFaModalTitle": "Configure Eversports 2FA",
    "twoFaMethod": "Method",
    "twoFaTotp": "TOTP (Authenticator app)",
    "twoFaEmail": "Email code",
    "twoFaSms": "SMS code",
    "twoFaSecretLabel": "Secret / code",
    "twoFaContactLabel": "Phone or email",
    "twoFaSecretPlaceholder": "Paste TOTP secret or code",
    "twoFaContactPlaceholder": "Phone number or email",
    "twoFaCodeLabel": "Clé d'authentification",
    "twoFaCodePlaceholder": "Coller la clé secrète TOTP de l'authentificateur",
    "twoFaCodeHint": "Trouvez cette clé dans la configuration de votre application d'authentification (ex. Google Authenticator, Authy). Le code sera généré automatiquement.",
    "save": "Sauvegarder",
    "toastStartFlowFailed": "Could not start connection flow.",
    "toastReconnectStarted": "Reconnect flow started.",
    "toastReconnectFailed": "Reconnect failed.",
    "toastDisconnected": "Disconnected.",
    "toastDisconnectFailed": "Disconnect failed.",
    "toastBookingCredentialsUpdated": "Booking platform credentials updated.",
    "toastBookingConnected": "Booking platform connected.",
    "toast2faConfigured": "2FA configured.",
    "errorUserPassRequired": "Username and password are required.",
    "errorSelectPlatform": "Please select a booking platform.",
    "errorInvalidCredentials": "Invalid credentials or platform unavailable. Please retry.",
    "errorGenericRetry": "Something went wrong. Please retry.",
    "error2faSecretRequired": "Secret or code is required.",
    "error2faCodeRequired": "La clé d'authentification est requise pour Eversports.",
    "errorUpdateFailed": "Update failed.",
    "errorConnectFailed": "Connect failed.",
    "errorConfigure2faFailed": "Failed to configure 2FA.",
    "errorNoStudioForApi": "Aucun studio n'est disponible pour ce compte. Ajoutez un studio avant de gérer les connexions.",
    "channelInstagram": "Instagram",
    "channelWhatsapp": "WhatsApp",
    "channelBooking": "Plateforme de réservation",
    "profile": {
      "viewProfile": "Voir le profil",
      "whatsappTitle": "Connexion WhatsApp",
      "instagramTitle": "Connexion Instagram",
      "sectionAssets": "Compte et ressources",
      "sectionTemplates": "Modèles de messages",
      "templatesSubtitle": "Les modèles doivent être approuvés par Meta avant utilisation en dehors de la fenêtre de 24 heures.",
      "expand": "Agrandir le panneau",
      "collapse": "Réduire le panneau",
      "refresh": "Actualiser",
      "disconnect": "Déconnecter",
      "disconnectTitle": "Déconnecter le canal ?",
      "disconnectBody": "Cela supprime la connexion du canal pour ce studio. Vous pourrez vous reconnecter plus tard depuis Paramètres.",
      "templatesPickerHint": "Les modèles approuvés peuvent être sélectionnés dans Chats lors des réponses WhatsApp.",
      "loading": "Chargement des détails de connexion…",
      "pageName": "Page Facebook",
      "pageId": "ID de page",
      "emailTitle": "Connexion e-mail",
      "providerLabel": "Fournisseur",
      "providerGoogle": "Google",
      "providerMicrosoft": "Microsoft",
      "grantHealthWarning": "Votre connexion e-mail a expiré. Reconnectez-vous pour envoyer et recevoir des messages.",
      "errorLoadEmail": "Impossible de charger les détails de la connexion e-mail."
    },
    "whatsapp": {
      "templates": {
        "create": "Créer un modèle de message",
        "editTitle": "Voir et modifier le modèle",
        "editSubtitleEditable": "Modifiez la catégorie ou le corps du message, puis enregistrez. Meta réexaminera automatiquement le modèle.",
        "editSubtitleReadOnly": "Ce modèle est en attente ou approuvé et ne peut pas être modifié ici.",
        "saveChanges": "Enregistrer les modifications",
        "saveSuccess": "Modèle enregistré et envoyé à Meta pour révision",
        "saveFailed": "Impossible d'enregistrer les modifications du modèle",
        "nameLocked": "Le nom du modèle ne peut pas être modifié après sa création",
        "submit": "Soumettre pour approbation",
        "testSend": "Envoi test",
        "preview": "Aperçu",
        "reviewPresets": "Modèles OktoGo recommandés",
        "testSendDialogTitle": "Envoyer un message test",
        "testSendSuccess": "Message test mis en file",
        "testSendFailed": "Échec de l'envoi test",
        "createSuccess": "Modèle soumis à Meta",
        "createFailed": "Impossible de créer le modèle",
        "submitFailed": "Impossible de soumettre le modèle pour approbation",
        "emptyProfile": "Aucun modèle de message. Créez-en un pour envoyer des messages en dehors de la fenêtre de 24 heures.",
        "nameHint": "Minuscules, chiffres et underscores uniquement",
        "nameInvalid": "Le nom doit être en minuscules avec lettres, chiffres et underscores",
        "bodyRequired": "Le corps du modèle est requis",
        "bodyLabel": "Corps du message",
        "bodyPlaceholderHint": "Utilisez {{1}}, {{2}}, … pour les valeurs dynamiques. Meta exige un exemple pour chaque variable.",
        "variableSamplesTitle": "Exemples de variables pour l'examen Meta",
        "variableSamplesHint": "Fournissez des exemples réalistes. Meta rejette les modèles sans exemples (INVALID_FORMAT).",
        "variableSampleLabel": "Exemple pour {{index}}",
        "variableSamplePlaceholder": "Valeur d'exemple pour les examinateurs Meta",
        "variableSamplesRequired": "Saisissez un exemple pour chaque variable du message",
        "variableSampleMetaSlot": "Espace réservé Meta {{index}}",
        "variables": {
          "customerName": "Nom du client",
          "studioName": "Nom du studio",
          "managerName": "Nom du responsable",
          "className": "Nom du cours ou de la séance",
          "classDate": "Date du cours",
          "classTime": "Heure du cours",
          "followUpNote": "Message de suivi",
          "visitDatetime": "Date et heure de la visite",
          "bookingDate": "Date de réservation",
          "bookingTime": "Heure de réservation",
          "newDate": "Nouvelle date",
          "newTime": "Nouvelle heure",
          "spotDate": "Date de la place",
          "spotTime": "Heure de la place",
          "handoffNote": "Message de transfert",
          "reengagementNote": "Message de réengagement",
          "rebookOffer": "Offre de nouvelle réservation",
          "membershipType": "Type d'abonnement",
          "renewalDate": "Date de renouvellement",
          "propertyName": "Nom de la propriété",
          "checkinDate": "Date d'arrivée",
          "accessDetails": "Détails d'accès"
        },
        "testSendTo": "Destinataire (numéro E.164)",
        "e164Invalid": "Saisissez un numéro E.164 valide (ex. +33612345678)",
        "variableLabel": "Variable {{index}}",
        "delete": "Supprimer le modèle",
        "deleteConfirmTitle": "Supprimer le modèle de message ?",
        "deleteConfirmBody": "Supprimer « {{name}} » (statut : {{status}}) ? Ce modèle sera retiré de Meta. Vous devrez peut-être le recréer pour envoyer des messages hors de la fenêtre de 24 heures. Les modèles bootstrap OktoGo peuvent devoir être recréés.",
        "deleteConfirmAction": "Supprimer le modèle",
        "deleteSuccess": "Modèle supprimé",
        "deleteFailed": "Impossible de supprimer le modèle",
        "deleteNotDeletable": "Ce modèle ne peut pas être supprimé tant qu'il est en attente ou approuvé",
        "rejectionReason": "Motif de rejet : {{reason}}",
        "presetClassReminder": "Rappel de cours avec détails de réservation (envoi démo T-1)",
        "presetSupportFollowup": "Suivi manager après escalade IA (T-2)",
        "presetTrialWelcome": "Bienvenue essai — démo création/soumission (T-3)",
        "catalog": {
          "classReminder": "Rappel de cours ou séance avec date, heure et option de modification",
          "supportFollowup": "Suivi manager après transfert du copilote IA ou demande ouverte",
          "trialWelcome": "Confirmation de séance d'essai ou première visite",
          "bookingConfirmed": "Confirmation de réservation après réservation studio ou IA",
          "bookingCancelled": "Avis d'annulation avec option de nouvelle réservation",
          "bookingRescheduled": "Changement de date ou d'heure de réservation",
          "waitlistAvailable": "Place en liste d'attente — inviter le client à réserver",
          "aiHandoff": "Copilote IA escaladé — un manager répondra bientôt",
          "inactiveReengagement": "Relance client hors fenêtre de messagerie 24 h",
          "classCancelledStudio": "Cours ou séance annulé par le studio",
          "membershipRenewal": "Rappel de renouvellement d'abonnement ou forfait",
          "stayCheckin": "Détails d'arrivée location courte durée et aide avant check-in"
        }
      }
    },
    "instagram": {
      "humanAgentEligible": "Éligible Human Agent",
      "humanAgentEligibleYes": "Oui",
      "humanAgentEligibleNo": "Non"
    },
    "webhookPending": {
      "banner": "Connexion active, mais la livraison des messages est en attente de vérification",
      "reverify": "Revérifier le webhook"
    },
    "whatsappActivate": {
      "banner": "WhatsApp est lié mais pas encore activé pour la messagerie. Saisissez votre code PIN WhatsApp à 6 chiffres pour terminer la configuration.",
      "cta": "Terminer l'activation",
      "title": "Terminer l'activation WhatsApp",
      "description": "Saisissez le code PIN à 6 chiffres de la vérification en deux étapes WhatsApp. Ne modifiez pas le PIN dans WhatsApp Manager au préalable — terminez l'activation ici pour que Meta enregistre le numéro auprès de l'API Cloud. OktoGo ne stocke pas ce PIN.",
      "pinLabel": "Code PIN WhatsApp",
      "pinPlaceholder": "PIN à 6 chiffres",
      "submit": "Activer",
      "cancel": "Annuler",
      "close": "Fermer",
      "success": "WhatsApp est activé pour la messagerie.",
      "errors": {
        "pinInvalid": "Le PIN ne correspond pas à la vérification en deux étapes WhatsApp.",
        "reverificationRequired": "WhatsApp exige une nouvelle vérification du téléphone dans Meta Business.",
        "rateLimited": "Trop de tentatives. Réessayez dans un délai pouvant aller jusqu'à 72 heures.",
        "generic": "Échec de l'activation. Veuillez réessayer.",
        "network": "Erreur réseau lors de l'activation."
      }
    },
    "firstTrialReadiness": {
      "title": "État des liens premier essai",
      "precedenceNote": "Modifiez ces liens dans Données du studio → Général. Connexions affiche uniquement leur état.",
      "scenario1Ready": "Scénario 1 prêt : lien inscription/essai configuré",
      "scenario1Missing": "Scénario 1 : lien inscription/essai manquant",
      "scenario2Ready": "Scénario 2 prêt : page Eversports du studio configurée",
      "scenario2Missing": "Scénario 2 : page Eversports du studio manquante",
      "ctaStudioData": "Ouvrir Studio Data",
      "ctaAiSettings": "Ouvrir AI Settings"
    }
  },
  "archive": {
    "permissionToast": "Vous n’avez pas l’autorisation d’accéder à l’archive.",
    "restoreError": "Restauration impossible",
    "studioLimitReached": "Maximum 5 studios actifs. Archivez-en un avant de restaurer ce studio.",
    "conversationRestored": "Conversation restaurée",
    "studioRestored": "Studio restauré",
    "deleteError": "Suppression impossible",
    "deleteBlockedFeedback": "Cette conversation comporte des retours IA et ne peut pas être supprimée définitivement. Elle reste archivée.",
    "conversationDeleted": "Conversation définitivement supprimée",
    "studioDeleted": "Studio définitivement supprimé",
    "loadError": "Impossible de charger l’archive.",
    "empty": "Aucun élément archivé pour le moment",
    "noFilterResults": "Aucun résultat pour les filtres actuels.",
    "columnName": "Nom",
    "columnType": "Type",
    "columnStudio": "Studio",
    "columnArchived": "Archivé",
    "columnActions": "Actions",
    "channelTitle": "Canal",
    "channelWhatsapp": "WhatsApp",
    "channelInstagram": "Instagram",
    "channelUnknown": "—",
    "restore": "Restaurer",
    "deleteForever": "Supprimer définitivement",
    "purgeTitle": "Supprimer définitivement",
    "purgeBodyConversation": "Supprimer définitivement cette conversation archivée ({{name}}) ? Cette action est irréversible.",
    "purgeBodyStudio": "Supprimer définitivement ce studio archivé ({{name}}) ? Cette action est irréversible.",
    "purgeDangerConversation": "Tous les messages et métadonnées de cette conversation seront supprimés de la base de données.",
    "purgeDangerStudio": "Le studio et ses données associées seront définitivement supprimés de la base de données.",
    "loadMore": "Charger plus",
    "purgeConversationTitle": "Supprimer la conversation définitivement ?",
    "purgeConversationBody": "Cela supprime définitivement la conversation archivée. Cette action est irréversible.",
    "purgeStudioTitle": "Supprimer le studio définitivement ?",
    "purgeStudioBody": "Saisissez le nom du studio pour confirmer la suppression définitive.",
    "searchAria": "Rechercher dans l’archive par nom",
    "filter": {
      "panelTitle": "Filtre",
      "panelDescription": "Filtrer les discussions et studios archivés par type, studio et date d’archivage.",
      "filterArchiveAria": "Filtrer l’archive",
      "sectionType": "Type",
      "sectionStudio": "Studio",
      "sectionArchivedAgo": "Archivé il y a",
      "typeAll": "Tous",
      "typeChat": "Discussion",
      "typeStudio": "Studio",
      "allStudios": "Tous les studios",
      "filterByStudioAria": "Filtrer par studio",
      "tagTypeChat": "Type : discussion",
      "tagTypeStudio": "Type : studio",
      "tagStudio": "Studio : {{name}}",
      "tagArchived": "Archivé : {{label}}",
      "studioFallback": "Studio"
    },
    "time": {
      "all": "Toutes les dates",
      "today": "Aujourd’hui",
      "yesterday": "Hier",
      "this_week": "Cette semaine",
      "last_week": "La semaine dernière",
      "this_month": "Ce mois-ci",
      "last_month": "Le mois dernier",
      "this_year": "Cette année"
    },
    "rowType": {
      "conversation": "Discussion",
      "studio": "Studio"
    }
  },
  "studio": {
    "scopeAllStudiosRejected": "« Tous les studios » n'est pas disponible pour votre compte. Un studio unique a été sélectionné.",
    "scopeSwitchFailed": "Impossible de mettre à jour le contexte studio. Veuillez réessayer."
  },
  "vertical": {
    "fitness": {
      "dataSectionNavLabel": "Données studio",
      "dataSectionPageTitle": "Données studio",
      "dataSectionReadOnlyNoun": "Données studio",
      "dataSectionAddUnitExpandedLabel": "Ajouter un studio",
      "dataSectionListColumnTitle": "Studios",
      "dataSectionMobileDescription": "Gérez les infos du studio, la FAQ, les règles et le planning des cours.",
      "aggregateScopeLabel": "Tous les studios",
      "selectScopeActionLabel": "Choisir un studio",
      "overlaySelectScopeMessage": "Passez à un studio précis pour modifier les réglages.",
      "teamInviteUnitsMulti": "Studios (un ou plusieurs)",
      "teamInviteUnitsSingle": "Studio",
      "teamInviteNoUnitsAvailable": "Aucun studio disponible pour les invitations sur ce compte.",
      "teamInviteSelectAtLeastOne": "Sélectionnez au moins un studio.",
      "chatsConversationUnitLabel": "Studio",
      "chatsIdentificationMatchingCopy": "Nous associons ce contact à un membre du studio. Cela peut prendre un instant.",
      "agentTraceSelectScopeMessage": "Sélectionnez un studio pour charger les traces.",
      "agentTraceLoadErrorNeedsScope": "Sélectionnez un studio et saisissez un UUID d’exécution d’agent valide.",
      "agentTraceNoAuditEventsForUnit": "Aucun événement d’audit pour ce studio sur cette période.",
      "aiSettingsContactOwnerReadOnly": "Contactez le propriétaire du studio pour modifier les réglages IA.",
      "onboardingBookingConnectTitle": "Connecter la plateforme de réservation",
      "onboardingBookingConnectSubtitle": "Connectez votre plateforme pour synchroniser cours, plannings et abonnements.",
      "onboardingBookingUsernamePlaceholder": "vous@studio.com",
      "dashboardStatConversationsToday": "Conversations aujourd’hui",
      "dashboardStatHandledByAiPct": "Traitées par l’IA %",
      "dashboardStatBookingsMade": "Réservations effectuées",
      "dashboardStatAvgFirstResponse": "Première réponse moy.",
      "chatsMockJoinedBookingLine": "Inscrit sur Eversports",
      "chatsMockMembershipHeading": "Abonnement",
      "chatsMockScheduleHeading": "Cours",
      "chatsCustomerPanelPlatformsHeading": "Plateformes",
      "chatsCustomerPanelAggregatorLabel": "Agrégateur",
      "chatsCustomerPanelNetworkLabel": "Réseau",
      "chatsCustomerPanelPrimaryPlatformIdLabel": "ID client Eversports",
      "chatsCustomerPanelSecondaryPlatformIdLabel": "ID membre myClubs",
      "chatsCustomerPanelAggregatorIdLabel": "ID agrégateur",
      "chatsCustomerPanelCustomerRecordIdLabel": "ID client",
      "chatsCustomerPanelConversationRefLabel": "Conversation",
      "chatsUnmatchedNotFoundTitle": "Client introuvable dans Eversports",
      "chatsUnmatchedNotFoundBody": "Ce contact ne correspond à aucun membre connu. Une recherche manuelle peut être nécessaire.",
      "chatsIdentificationInProgressTitle": "Identification du client en cours",
      "chatsNoMembershipRecordTitle": "Aucun dossier d’abonnement",
      "chatsNoMembershipRecordBody": "Cela ressemble à une demande générale ou à un futur nouveau membre.",
      "visionAgentTraceButtonLabel": "Trace agent Vision",
      "pageScopeDescription": "Le tableau de bord, les discussions et les données studio ci-dessous suivent le studio choisi ici. Utilisez « Tous les studios » pour une vue agrégée lorsque c’est disponible.",
      "connectionsTableUnitColumn": "Studio",
      "settingsAccountVerticalTitle": "Verticale produit",
      "settingsAccountVerticalHint": "Fitness conserve le vocabulaire studio et cours. Location courte durée bascule les textes et canaux d’annonce vers un contexte bien."
    },
    "str": {
      "dataSectionNavLabel": "Données du bien",
      "dataSectionPageTitle": "Données du bien",
      "dataSectionReadOnlyNoun": "Données du bien",
      "dataSectionAddUnitExpandedLabel": "Ajouter un bien",
      "dataSectionListColumnTitle": "Biens",
      "dataSectionMobileDescription": "Gérez les infos du bien, la FAQ, les règles et les détails visibles par les voyageurs.",
      "aggregateScopeLabel": "Tous les biens",
      "selectScopeActionLabel": "Choisir un bien",
      "overlaySelectScopeMessage": "Passez à un bien précis pour modifier les réglages.",
      "teamInviteUnitsMulti": "Biens (un ou plusieurs)",
      "teamInviteUnitsSingle": "Bien",
      "teamInviteNoUnitsAvailable": "Aucun bien disponible pour les invitations sur ce compte.",
      "teamInviteSelectAtLeastOne": "Sélectionnez au moins un bien.",
      "chatsConversationUnitLabel": "Bien",
      "chatsIdentificationMatchingCopy": "Nous associons ce contact à un voyageur ou une réservation. Cela peut prendre un instant.",
      "agentTraceSelectScopeMessage": "Sélectionnez un bien pour charger les traces.",
      "agentTraceLoadErrorNeedsScope": "Sélectionnez un bien et saisissez un UUID d’exécution d’agent valide.",
      "agentTraceNoAuditEventsForUnit": "Aucun événement d’audit pour ce bien sur cette période.",
      "aiSettingsContactOwnerReadOnly": "Contactez le propriétaire du bien pour modifier les réglages IA.",
      "onboardingBookingConnectTitle": "Connecter le canal d’annonce",
      "onboardingBookingConnectSubtitle": "Connectez votre plateforme d’annonces ou de réservations pour synchroniser disponibilité, réservations et infos voyageurs.",
      "onboardingBookingUsernamePlaceholder": "vous@exemple.com",
      "dashboardStatConversationsToday": "Conversations aujourd’hui",
      "dashboardStatHandledByAiPct": "Traitées par l’IA %",
      "dashboardStatBookingsMade": "Réservations confirmées",
      "dashboardStatAvgFirstResponse": "Première réponse moy.",
      "chatsMockJoinedBookingLine": "Canal de réservation principal",
      "chatsMockMembershipHeading": "Programme voyageurs",
      "chatsMockScheduleHeading": "Séjours à venir",
      "chatsCustomerPanelPlatformsHeading": "Canaux",
      "chatsCustomerPanelAggregatorLabel": "Canal principal",
      "chatsCustomerPanelNetworkLabel": "Partenaire",
      "chatsCustomerPanelPrimaryPlatformIdLabel": "ID voyageur",
      "chatsCustomerPanelSecondaryPlatformIdLabel": "Réf. réservation",
      "chatsCustomerPanelAggregatorIdLabel": "Réf. source",
      "chatsCustomerPanelCustomerRecordIdLabel": "ID dossier voyageur",
      "chatsCustomerPanelConversationRefLabel": "Conversation",
      "chatsUnmatchedNotFoundTitle": "Voyageur introuvable dans le système de réservation",
      "chatsUnmatchedNotFoundBody": "Ce contact ne correspond à aucun voyageur ou réservation connu. Une recherche manuelle peut être nécessaire.",
      "chatsIdentificationInProgressTitle": "Identification du voyageur en cours",
      "chatsNoMembershipRecordTitle": "Aucune réservation enregistrée",
      "chatsNoMembershipRecordBody": "Cela ressemble à une demande générale ou à une nouvelle réservation potentielle.",
      "visionAgentTraceButtonLabel": "Trace agent Vision",
      "pageScopeDescription": "Le tableau de bord, les discussions et les données du bien ci-dessous suivent le bien choisi ici. Utilisez « Tous les biens » pour une vue agrégée lorsque c’est disponible.",
      "connectionsTableUnitColumn": "Bien",
      "settingsAccountVerticalTitle": "Verticale produit",
      "settingsAccountVerticalHint": "La location courte durée utilise le vocabulaire bien et voyageur avec les canaux d’annonce. Fitness utilise studio et cours."
    }
  },
  "notFound": {
    "code": "404",
    "title": "Oups ! Page introuvable",
    "home": "Retour à l’accueil"
  },
  "setupNotComplete": {
    "title": "Configuration du studio incomplète",
    "body": "Le propriétaire du studio n’a pas encore terminé la configuration. Vous aurez accès une fois la configuration terminée."
  },
  "routeErrorBoundary": {
    "summary": "Cette page n’a pas pu se charger. Veuillez réessayer en rechargeant la page.",
    "reload": "Recharger la page"
  },
  "ai": {
    "readOnlyContactOwner": "Contactez le propriétaire du studio pour modifier les réglages IA.",
    "readOnlyContactOwnerStr": "Contactez le propriétaire du bien pour modifier les réglages IA.",
    "sectionReplies": "Réponses par sujet",
    "regimeLockedBanner": "Pendant le pilote, l’envoi automatique reste désactivé pour tous les sujets. Contactez OktoGo pour déverrouiller le basculeur Auto/Manuel.",
    "toastRegimeLocked": "L’envoi automatique est verrouillé pour ce studio pilote. Contactez OktoGo pour le déverrouiller.",
    "sectionTone": "Ton de conversation",
    "sectionLearn": "Apprendre des réponses de l’équipe",
    "sectionAttribution": "Libellés des réponses IA automatiques",
    "sectionEscalation": "Règles d’escalade",
    "sectionEscalationHint": "Quand signaler une conversation pour votre vérification (escalade légère). L'IA rédige toujours un brouillon — vous l'approuvez ou le modifiez avant l'envoi. La reprise en main — quand un client demande un humain, ou que l'IA ne peut pas terminer en toute sécurité — est une ceinture de sécurité séparée, non contrôlée par ces règles.",
    "sectionSessionNudge": "Relances de session de messagerie",
    "sectionSessionNudgeHint": "Message court optionnel au client avant la fin de la fenêtre WhatsApp en texte libre. S’exécute seulement si l’automatisation serveur est activée ; un brouillon IA en attente annule l’envoi.",
    "escalationStillDraftsNote": "Qu’elles soient signalées par ces règles ou par une reprise de sécurité, les conversations escaladées attendent votre approbation — sauf les messages de confirmation d’identité, toujours envoyés pour que le client puisse commencer. L'IA continue à rédiger des suggestions de réponse pour que vous ne partiez jamais de zéro.",
    "save": "Sauvegarder",
    "saving": "Enregistrement…",
    "saved": "Réglages IA enregistrés.",
    "saveError": "Impossible d’enregistrer les réglages IA.",
    "loadError": "Impossible de charger les réglages IA.",
    "bookingRequiredTitle": "Connectez d’abord une plateforme de réservation",
    "bookingRequiredBody": "L’activation de la gestion automatique pour les sujets liés aux réservations fonctionne mieux lorsqu’une plateforme est connectée dans Réglages → Canaux.",
    "confirmEnableBooking": "Activer sans plateforme de réservation connectée ?",
    "enable": "Activer",
    "useCase": {
      "booking": "Nouvelle réservation",
      "rebook": "Modifier la réservation",
      "cancel": "Annulation",
      "info": "Informations générales",
      "schedule": "Demande de créneau",
      "trial": "Essai / première visite",
      "account": "Compte / abonnement",
      "campaignLead": "Prospect de campagne"
    },
    "firstTrial": {
      "helper": {
        "title": "Essai / première visite — Copilot choisit le parcours pour vous :",
        "scenario1": "Pas de compte sur la plateforme de réservation → lien d’inscription / d’essai",
        "scenario2": "Compte Eversports existant, nouveau dans votre studio → page Eversports du studio ; les réservations restent en brouillon tant que la personne n’est pas liée à votre studio",
        "scenario2Booking": "Après liaison, les règles de réservation habituelles s’appliquent (ligne « Nouvelle réservation »)"
      },
      "readiness": {
        "title": "État des liens premier essai",
        "precedenceNote": "Modifiez ces liens dans Données du studio → Général. Connexions affiche uniquement leur état.",
        "scenario1Ready": "Scénario 1 prêt : lien inscription/essai configuré",
        "scenario1Missing": "Scénario 1 : lien inscription/essai manquant",
        "scenario2Ready": "Scénario 2 prêt : page Eversports du studio configurée",
        "scenario2Missing": "Scénario 2 : page Eversports du studio manquante",
        "ctaStudioData": "Ouvrir Studio Data",
        "ctaConnections": "Ouvrir Connections"
      }
    },
    "tone": {
      "friendly": {
        "label": "Amical",
        "desc": "Chaleureux, approcheable, avec emojis. Commence par le tutoiement. Passe au vouvoiement si le client ou l’équipe écrit clairement vous."
      },
      "professional": {
        "label": "Formel",
        "desc": "Soutenu, formel, sans emojis. Commence par le vouvoiement. Passe au tutoiement si le client ou l’équipe écrit ensuite clairement tu."
      },
      "casual": {
        "label": "Décontracté",
        "desc": "Décontracté et court. Commence par le tutoiement. Passe au vouvoiement si le client ou l’équipe écrit clairement vous."
      }
    },
    "repliesByTopicDesc": "Auto : après les vérifications et la confirmation client si requise (ex. modification de réservation), l’IA peut exécuter l’action et envoyer une confirmation vérifiée. Manuel : après ces mêmes contrôles et la confirmation client, l’IA attend votre validation avant tout changement sur la plateforme et avant la confirmation.",
    "repliesByTopicManualWait": "En Manuel, ces sujets attendent votre validation.",
    "repliesByTopicStillSentChip": "Envoyés quand même tout seuls : confirmer qui il est, déjà inscrit au cours, un « c’est fait » plus tard, un « vous êtes vérifié » plus tard, et un « j’annule ? » avant votre confirmation. Rien d’autre.",
    "approveAllFirst": "Approuver d’abord tous les messages",
    "autoSendAllMessages": "Envoyer automatiquement tous les messages",
    "bookingUseCaseHint": "Connectez une intégration dans Réglages → Canaux pour utiliser les données de planning et de réservation en direct.",
    "toneSectionDesc": "Style de départ pour chaque conversation. Le fil peut devenir plus formel ou plus informel si le client ou l’équipe utilise ensuite un tutoiement ou un vouvoiement clair.",
    "learnSectionDesc": "L’IA reprend la façon d’écrire de l’équipe — longueur, chaleur, formule de fin. Un Sie/du (vous/tu) d’équipe clair suffit pour la suggestion suivante. Le dernier tutoiement ou vouvoiement clair du client ou de l’équipe l’emporte. Sans exemple clair, le style de départ ci-dessus s’applique.",
    "attributionSectionDesc": "Les réponses IA envoyées automatiquement s’affichent toujours sous ce nom d’assistant dans les discussions. Vous ne pouvez pas désactiver les libellés. WhatsApp et Instagram utilisent toujours votre compte professionnel connecté — pas ce nom.",
    "attributionDisplayNameLabel": "Nom d’affichage de l’assistant",
    "attributionDisplayNameHint": "Saisissez uniquement le nom — AI est ajouté automatiquement et ne peut pas être retiré. Exemple : Kai → Kai AI. Les clients WhatsApp et Instagram voient toujours votre compte professionnel connecté.",
    "attributionDisplayNameErrorEmpty": "Saisissez un nom pour l’assistant.",
    "attributionDisplayNameErrorToken": "Saisissez un nom pour l’assistant.",
    "attributionDisplayNameAiSuffixTitle": "AI est toujours ajouté après le nom",
    "attributionDisplayNameAiSuffixSr": "AI est fixe après le nom et ne peut pas être modifié.",
    "attributionDisplayNameSave": "Enregistrer le nom de l’assistant",
    "attributionDisplayNameReset": "Réinitialiser par défaut",
    "attributionBackendPendingHint": "L’enregistrement n’est pas encore disponible — le serveur doit encore exposer l’API du nom d’assistant. Vous pouvez rédiger et valider le nom ici.",
    "attributionStudio": "Nom du studio",
    "attributionAi": "Assistant IA",
    "attributionLockedHint": "Seul le propriétaire ou le gestionnaire peut modifier ce réglage.",
    "toastAttributionSaved": "Nom d’affichage de l’assistant enregistré.",
    "toastAttributionBackendNotReady": "Enregistrement impossible pour l’instant — le nom d’affichage de l’assistant n’est pas disponible sur le serveur.",
    "escalateAfterPrefix": "Escalader après",
    "escalateAfterSuffix": "tentatives infructueuses avant de signaler la conversation pour votre vérification.",
    "dialogEnableAutoSendTitle": "Activer l’envoi automatique",
    "dialogEnableAutoSendBody": "Après les vérifications requises et la confirmation client si le parcours l’exige (ex. modification = annuler + réserver), l’IA peut exécuter cette action et envoyer une confirmation vérifiée sans votre validation. En mode manuel, elle attend votre validation avant tout changement sur la plateforme et avant la confirmation. Continuer ?",
    "dialogAutoSendAllTitle": "Envoyer automatiquement tous les messages",
    "dialogAutoSendAllBody": "Pour une réservation, une modification ou une annulation, l’IA n’agit qu’après les vérifications requises et la confirmation client si le parcours l’exige (modification = une confirmation pour annuler + réserver ensemble). En mode manuel, elle attend votre validation avant tout changement sur la plateforme et avant la confirmation.",
    "enableAll": "Tout activer",
    "toastSettingSaveError": "Impossible d’enregistrer ce réglage.",
    "toastAttributionError": "Échec de la mise à jour des libellés de réponses automatiques.",
    "toastEscalationError": "Échec de la mise à jour des règles d’escalade.",
    "sessionNudgeEnabled": "Activer la relance automatique de session",
    "sessionNudgeWhatsapp": "WhatsApp",
    "sessionNudgeInstagram": "Instagram (expérimental)",
    "sessionNudgeOnlyEscalated": "Seulement si escaladé",
    "sessionNudgeMaxOne": "Au plus une relance par escalade",
    "sessionNudgeWhenRemaining": "Envoyer lorsque le temps restant est au plus",
    "sessionNudgeHours4": "4 heures",
    "sessionNudgeHours6": "6 heures",
    "sessionNudgeHours8": "8 heures",
    "sessionNudgePreview": "Aperçu du message par défaut",
    "sessionNudgePreviewMayDiffer": "Le message réel peut sonner plus ou moins formel selon la conversation, en fonction de la façon dont votre équipe écrit à ce client.",
    "toastSessionNudgeError": "Impossible d’enregistrer les paramètres de relance de session.",
    "toastAutoHandleError": "Échec de la mise à jour de la gestion automatique.",
    "toastAutoHandleRateLimited": "Trop de modifications à la fois. Veuillez réessayer dans un instant.",
    "toastAutoHandleRateLimitedWithRetry": "Trop de modifications à la fois. Réessayez dans environ {{seconds}} secondes.",
    "toastToneError": "Échec de la mise à jour du ton.",
    "toastGenericUpdateError": "Impossible de mettre à jour les réglages.",
    "connectBookingFirst": "Connectez d’abord une plateforme de réservation dans Réglages → Canaux.",
    "connectListingFirst": "Connectez d’abord un canal d’annonce dans Réglages → Canaux.",
    "campaignLeadNotReady": "Configurez d’abord une campagne prête dans Données du studio → Campagnes avant d’activer ceci.",
    "campaignLead": {
      "hintNoCampaign": "Aucune campagne configurée pour le moment",
      "hintNotReady": "Campagne pas encore prête",
      "hintEndDateMissing": "Il manque une date de fin à la campagne",
      "hintEndingSoon": "La campagne se termine le {{date}}",
      "hintExpired": "La dernière campagne a expiré",
      "hintSummaryActive": "{{count}} active(s)",
      "hintSummaryScheduled": "{{count}} planifiée(s)",
      "hintSummaryNotReady": "{{count}} non prête(s)",
      "hintSummaryExpired": "{{count}} expirée(s)",
      "ctaOpenCampaigns": "Ouvrir Campagnes"
    },
    "groupBooking": {
      "sectionTitle": "Réservations de groupe",
      "sectionDesc": "Copilot détecte les demandes de groupe et d’entreprise dans la conversation et les traite avec sécurité plutôt que de réserver des places individuelles.",
      "tabsAriaLabel": "Sections des paramètres de réservations de groupe",
      "tabBasics": "Général",
      "tabPolicies": "Politiques",
      "lockAria": "Réservé au propriétaire",
      "enableLabel": "Activer les réservations de groupe pour ce studio",
      "enableHint": "Lorsque c’est activé, les conversations de type groupe reçoivent un brouillon en attente et une checklist pour le manager au lieu d’un envoi automatique.",
      "fulfillmentLabel": "Comment traiter les réservations de groupe ?",
      "fulfillment": {
        "manual": "Manuel",
        "semiAutomated": "Semi-automatique",
        "fullyAutomated": "Entièrement automatique",
        "manualDesc": "Copilot rédige des brouillons et affiche une checklist du roster ; vous réservez manuellement dans le manager de votre plateforme.",
        "semiAutomatedDesc": "Copilot rédige des brouillons ; après votre validation, il peut exécuter des étapes sûres du roster dans le manager de la plateforme lorsqu’il est prêt.",
        "fullyAutomatedDesc": "Pilote uniquement. Copilot peut exécuter des étapes sûres avant validation ; vous supervisez et pouvez intervenir à tout moment.",
        "requiresConnection": "Semi-automatique et Entièrement automatique nécessitent une plateforme de réservation connectée. Connectez-en une dans Paramètres → Canaux."
      },
      "maxPartyLabel": "Plus grand groupe que Copilot peut automatiser",
      "maxPartyHint": "S’applique uniquement aux modes Semi-automatique et Entièrement automatique. Les groupes plus grands restent manuels. Plage 2–50.",
      "escalationTargetLabel": "Notifier pour la prise en main",
      "escalationTargetHint": "Qui est alerté lorsqu’une réservation de groupe nécessite un humain. Livraison : Chats lorsque vous êtes dans Copilot ; notification mobile lorsque vous êtes absent (selon Compte → Notifications).",
      "escalationTarget": {
        "owner": "Propriétaire du studio",
        "allChatMembers": "Tous les managers ayant accès aux chats"
      },
      "saveButton": "Enregistrer la politique de réservations de groupe",
      "toastSaved": "Politique de réservations de groupe enregistrée.",
      "toastSaveError": "Impossible d’enregistrer la politique de réservations de groupe.",
      "toastEndpointUnavailable": "L’API de politique de réservations de groupe n’est pas encore disponible sur ce serveur. Les réglages s’appliqueront lorsque votre administrateur déploiera la mise à jour backend.",
      "toastLoadUnavailable": "Impossible de charger les paramètres IA depuis le serveur.",
      "endpointUnavailableHint": "L’enregistrement est désactivé tant que le point de terminaison de politique n’est pas disponible."
    },
    "escalation": {
      "no_match": "Aucune intention reconnue",
      "sentiment": "Sentiment négatif détecté",
      "repeat": "Le client répète sa demande 3 fois ou plus",
      "explicit": "Le client demande un humain"
    }
  },
  "channelConnect": {
    "header": {
      "connectInstagram": "Connecter Instagram",
      "connectWhatsapp": "Connecter WhatsApp",
      "selectStudioTooltip": "Sélectionnez un studio pour connecter les canaux"
    },
    "wizard": {
      "yes": "Oui",
      "no": "Non",
      "continue": "Continuer",
      "back": "Retour",
      "cancel": "Annuler",
      "retry": "Réessayer",
      "learnMore": "En savoir plus",
      "instagram": {
        "title": "Connecter Instagram",
        "introBody": "Connectez votre compte Instagram professionnel pour que Oktogo gère les messages clients dans Chats.",
        "q1": "Avez-vous déjà un compte Instagram professionnel (Business ou Creator) ?",
        "q1Yes": "Oui, j'ai un compte professionnel",
        "q1No": "Non, pas encore",
        "q1HelpTitle": "Passer en compte professionnel",
        "q1Help": "Ouvrez Instagram → Paramètres → Compte → Passer à un compte professionnel, puis choisissez Business ou Creator.",
        "q2": "Votre compte Instagram est-il lié à une Page Facebook ?",
        "q2Yes": "Oui, il est lié à une Page Facebook",
        "q2No": "Non, pas encore lié",
        "q2HelpTitle": "Lier Instagram à une Page Facebook",
        "q2Help": "Dans Meta Business Suite ou les paramètres de la Page Facebook, connectez votre compte Instagram à la Page de votre studio.",
        "q3": "L'accès aux messages est-il activé pour ce compte Instagram ?",
        "q3Yes": "Oui, l'accès aux messages est activé",
        "q3No": "Non, pas encore activé",
        "q3HelpTitle": "Activer l'accès aux messages",
        "q3Help": "Dans l'app Instagram : Paramètres → Messages → Contrôles des messages → autoriser l'accès pour les outils connectés.",
        "confirm": "Connecter Instagram",
        "checkProfessional": "Compte Instagram professionnel (Business ou Creator)",
        "checkFacebookPage": "Instagram lié à une Page Facebook",
        "checkMessageAccess": "Accès aux messages activé"
      },
      "whatsapp": {
        "title": "Connecter WhatsApp",
        "introBody": "Connectez WhatsApp Business pour que Oktogo gère les messages clients dans Chats.",
        "q1": "Avez-vous un compte WhatsApp Business (ou un numéro éligible à l'API Business) ?",
        "q1Yes": "Oui, j'ai WhatsApp Business",
        "q1No": "Non, pas encore",
        "q1HelpTitle": "Configurer WhatsApp Business",
        "q1Help": "Installez WhatsApp Business sur le téléphone du studio ou enregistrez un numéro auprès de Meta pour l'API Business.",
        "q2": "Pouvez-vous vous connecter avec le compte Meta qui administre cette entreprise ?",
        "q2Yes": "Oui, j'ai un accès administrateur Meta",
        "q2No": "Non, je n'ai pas d'accès administrateur",
        "q2HelpTitle": "Accès administrateur Meta",
        "q2Help": "Vous devez avoir un accès administrateur au compte Meta Business qui possède le profil WhatsApp Business.",
        "confirm": "Connecter WhatsApp",
        "checkBusiness": "Compte WhatsApp Business prêt",
        "checkMetaAccess": "Accès administrateur Meta confirmé"
      }
    },
    "oauth": {
      "successInstagram": "Instagram connecté",
      "successInstagramHandle": "Connecté en tant que {{handle}}",
      "successWhatsapp": "WhatsApp connecté",
      "webhookPending": "Instagram est connecté, mais la livraison des messages est en attente de vérification."
    },
    "errors": {
      "accessDenied": "Vous avez annulé les autorisations. Réessayez quand vous serez prêt.",
      "connectFailed": "Échec de la connexion. Veuillez réessayer."
    },
    "email": {
      "connect": "Connecter l’e-mail",
      "connectTooltip": "Connecter une boîte partagée pour les e-mails clients dans Chats (tous les studios)",
      "wizard": {
        "title": "Connecter l’e-mail",
        "introBody": "Connectez la boîte mail de votre studio pour que OktoGo gère les fils e-mail clients dans Chats.",
        "providerGoogle": "Google (Gmail / Google Workspace)",
        "providerMicrosoft": "Microsoft (Outlook / Microsoft 365)",
        "prereqsTitle": "Avant de connecter",
        "prereqsBody": "Utilisez un compte auquel vous pouvez vous connecter avec Google ou Microsoft. Vous devez avoir l’autorisation de connecter cette boîte pour votre entreprise.",
        "confirm": "Connecter l’e-mail",
        "defaultStudioLabel": "Studio par défaut pour les nouveaux fils e-mail",
        "defaultStudioHint": "Les nouveaux e-mails entrants sont routés vers ce studio jusqu’à clarification du client.",
        "openChats": "Ouvrir Chats"
      },
      "oauth": {
        "success": "E-mail connecté",
        "successAddress": "Connecté en tant que {{address}}"
      }
    }
  },
  "whatsappSignup": {
    "title": "Connecter WhatsApp Business",
    "description": "Autorisez OktoGo à gérer les messages pour votre compte WhatsApp Business.",
    "connectButton": "Se connecter avec Meta",
    "fbFlow": "Terminez la connexion dans la fenêtre Meta…",
    "saving": "Enregistrement de la connexion…",
    "successRedirect": "WhatsApp connecté ! Redirection…",
    "hint": "Vous vous connecterez à Meta et sélectionnerez votre compte WhatsApp Business.",
    "metaCompleteHint": "L'autorisation Meta est terminée. Saisissez votre code PIN ci-dessous pour finaliser la connexion dans OktoGo.",
    "pinDescription": "Saisissez le code PIN à 6 chiffres de la vérification en deux étapes WhatsApp pour enregistrer ce numéro auprès de l'API Cloud Meta.",
    "pinLabel": "Code PIN WhatsApp",
    "pinPlaceholder": "PIN à 6 chiffres",
    "pinSubmit": "Activer et connecter",
    "retry": "Réessayer",
    "errors": {
      "generic": "Une erreur s'est produite.",
      "missingConfig": "Configuration Meta manquante. Vérifiez VITE_META_APP_ID et VITE_META_ES_CONFIG_ID.",
      "phoneAlreadyConnected": "Ce numéro de téléphone est déjà connecté à un autre studio de votre compte.",
      "metaExchangeFailed": "Meta n'a pas pu échanger le code. Vérifiez l'URI de redirection serveur.",
      "wabaDiscoveryFailed": "Compte WhatsApp Business introuvable. Assurez-vous d'avoir un WABA avec un numéro.",
      "studioContextRequired": "Sélectionnez un studio précis avant de connecter WhatsApp, puis réessayez depuis Paramètres ou Discussions.",
      "connectFailed": "Échec de l'enregistrement de la connexion WhatsApp. Réessayez.",
      "sessionExpired": "Votre session a expiré. Reconnectez-vous, puis reliez WhatsApp depuis les paramètres.",
      "network": "Erreur réseau lors de l'enregistrement. Réessayez.",
      "cancelled": "Connexion Meta annulée. Réessayez.",
      "sdkLoadFailed": "Impossible de charger le SDK Meta. Actualisez la page.",
      "activationRequired": "Saisissez votre code PIN WhatsApp à 6 chiffres pour activer la messagerie.",
      "pinInvalid": "Le PIN ne correspond pas à la vérification en deux étapes WhatsApp.",
      "reverificationRequired": "WhatsApp exige une nouvelle vérification du téléphone dans Meta Business.",
      "registerRateLimited": "Trop de tentatives d'enregistrement. Réessayez dans un délai pouvant aller jusqu'à 72 heures.",
      "registerFailed": "Échec de l'enregistrement du numéro WhatsApp. Veuillez réessayer."
    }
  },
  "whatsappTemplates": {
    "title": "Modèles de messages",
    "subtitle": "Modèles approuvés de votre compte WhatsApp Business connecté (hors fenêtre de 24 h).",
    "loading": "Chargement des modèles…",
    "empty": "Aucun modèle de message pour ce compte.",
    "errorLoad": "Impossible de charger les modèles de messages.",
    "retry": "Réessayer",
    "colName": "Nom",
    "colLanguage": "Langue",
    "colCategory": "Catégorie",
    "colStatus": "Statut"
  },
  "whatsappSetup": {
    "title": "Compte WhatsApp connecté",
    "subtitle": "Détails en direct du compte WhatsApp Business (WABA), numéro, vérification et abonnement webhook.",
    "loading": "Chargement des détails du compte…",
    "errorLoad": "Impossible de charger les détails du compte WhatsApp.",
    "retry": "Réessayer",
    "wabaId": "ID WABA",
    "phoneNumber": "Numéro de téléphone",
    "displayName": "Nom affiché",
    "phoneVerification": "Vérification du téléphone",
    "nameVerification": "Vérification du nom affiché",
    "webhookSubscription": "Abonnement webhook",
    "webhookSubscribed": "Abonné",
    "webhookNotSubscribed": "Non abonné",
    "webhookAppId": "ID d'application Meta",
    "webhookFields": "Champs abonnés"
  },
  "onboarding": {
    "shell": {
      "stepOf": "Étape {{current}} sur {{total}}",
      "exitAria": "Quitter la configuration",
      "exitTitle": "Enregistrer l'avancement et continuer plus tard ?",
      "exitDescription": "Votre progression sera enregistrée. Vous pourrez reprendre la configuration à votre prochaine connexion.",
      "cancel": "Annuler",
      "saveAndExit": "Enregistrer et quitter"
    },
    "instagram": {
      "title": "Connecter Instagram",
      "description": "Connectez votre compte Instagram Business pour qu'OktoGo gère les messages clients.",
      "errorConnect": "Échec de la connexion Instagram. Veuillez réessayer.",
      "connected": "Connecté",
      "connectButton": "Connecter Instagram",
      "retry": "Réessayer",
      "continue": "Continuer",
      "skipLater": "Je ferai cela plus tard",
      "testErrorEnable": "(Test : activer le mode erreur)",
      "testErrorDisable": "(Test : désactiver le mode erreur)"
    },
    "whatsapp": {
      "title": "Connecter WhatsApp Business",
      "description": "Connectez votre compte WhatsApp Business pour qu'OktoGo gère les messages clients.",
      "errorConnect": "Échec de la connexion WhatsApp. Veuillez réessayer.",
      "connected": "Connecté",
      "connectButton": "Connecter WhatsApp",
      "retry": "Réessayer",
      "continue": "Continuer",
      "skipLater": "Je ferai cela plus tard",
      "back": "Retour"
    },
    "booking": {
      "title": "Connecter la plateforme de réservation",
      "description": "Connectez votre plateforme pour synchroniser les cours, le planning et les abonnements.",
      "errorCredentials": "Identifiants invalides ou plateforme indisponible. Veuillez réessayer.",
      "connected": "Connecté",
      "continue": "Continuer",
      "platformLabel": "Plateforme de réservation",
      "usernameLabel": "Nom d'utilisateur / E-mail",
      "passwordLabel": "Mot de passe",
      "skipLater": "Je ferai cela plus tard",
      "disclosure": "Nous stockons vos identifiants en toute sécurité pour synchroniser réservations et planning. Votre mot de passe est chiffré et accessible uniquement aux serveurs sécurisés d'OktoGo.",
      "testConnection": "Tester la connexion",
      "back": "Retour",
      "testErrorEnable": "(Test : activer le mode erreur)",
      "testErrorDisable": "(Test : désactiver le mode erreur)",
      "manualCodeLabel": "Code de connexion supplémentaire",
      "manualCodeHint": "Eversports a envoyé un code à usage unique (SMS, e-mail ou application d'authentification). Saisissez-le puis relancez le test.",
      "manualCodeRequiredTitle": "Vérification manuelle requise"
    },
    "twoFa": {
      "title": "Configurer les identifiants 2FA",
      "description": "Eversports exige la 2FA. Fournissez vos identifiants pour qu'OktoGo s'authentifie en votre nom.",
      "errorVerify": "Échec de la vérification 2FA – vérifiez vos identifiants et réessayez.",
      "verified": "2FA vérifiée",
      "verifiedHint": "Authentification Eversports prête",
      "continue": "Continuer",
      "methodLabel": "Méthode 2FA",
      "methodAuthenticator": "Application d'authentification",
      "methodSms": "SMS",
      "methodBackup": "Code de secours",
      "secretLabel": "Secret 2FA / code de secours",
      "disclosure": "Vos identifiants 2FA sont chiffrés et stockés uniquement pour permettre à OktoGo de s'authentifier auprès d'Eversports en votre nom. Ils ne sont jamais partagés.",
      "skipLater": "Je ferai cela plus tard",
      "back": "Retour",
      "testButton": "Tester la 2FA",
      "syncLimitedHint": "La synchronisation peut être limitée tant que la 2FA n'est pas fournie",
      "testErrorEnable": "(Test : activer le mode erreur)",
      "testErrorDisable": "(Test : désactiver le mode erreur)"
    },
    "email": {
      "title": "Connecter l'e-mail",
      "description": "Connectez la boîte mail de votre studio pour qu'OktoGo gère les fils e-mail clients dans Chats.",
      "connectButton": "Connecter l'e-mail",
      "skipLater": "Plus tard",
      "back": "Retour",
      "continue": "Continuer",
      "connected": "E-mail connecté",
      "connectedHint": "Votre boîte mail est prête pour les e-mails clients dans Chats.",
      "optionalHint": "Facultatif — vous pourrez connecter l'e-mail plus tard dans Paramètres."
    },
    "messaging": {
      "title": "Connecter les canaux de messagerie",
      "description": "Connectez Instagram et WhatsApp pour qu'OktoGo gère les messages clients dans Chats.",
      "continue": "Continuer",
      "skipLater": "Plus tard",
      "back": "Retour",
      "optionalHint": "Facultatif — vous pourrez les connecter plus tard dans Paramètres → Canaux."
    },
    "oauthCallbackLoading": "Connexion du compte…",
    "errors": {
      "connectFailed": "Échec de la connexion. Veuillez réessayer."
    },
    "sync": {
      "titleRunning": "Synchronisation des données du studio…",
      "titleDone": "Synchronisation terminée !",
      "titleSkipped": "Vous êtes prêt pour l'instant",
      "hintRunning": "Cela ne prendra qu'un instant.",
      "hintDone": "Les données de votre studio ont été importées avec succès.",
      "hintSkipped": "Aucune plateforme de réservation connectée pour l'instant. Vous pourrez vous connecter plus tard depuis Paramètres → Connexions.",
      "stageClasses": "Récupération des cours",
      "stageSchedule": "Synchronisation du planning",
      "stageMemberships": "Import des abonnements",
      "stagePolicies": "Chargement des politiques",
      "continueDashboard": "Continuer vers le tableau de bord",
      "completing": "Finalisation…",
      "summaryDemo": "{{classes}} cours, {{sessions}} séances à venir, {{tiers}} niveaux d'abonnement importés.",
      "summaryReal": "{{classes}} cours et {{policies}} politiques importés avec succès.",
      "summaryGeneric": "Données du studio importées avec succès.",
      "summaryNoData": "Configuration terminée. Vous pourrez connecter une plateforme de réservation plus tard depuis Paramètres → Connexions.",
      "confirmTitle": "Confirmez vos liens publics Eversports",
      "confirmLinks": "Vérifiez les URL Overview, Classes et Prices dans Studio Data → Général.",
      "confirmClassPrices": "Les descriptions de cours et Pricing options synchronisent depuis Eversports lorsqu’elles sont disponibles — consultez-les sous Studio Data → Cours.",
      "confirmHonesty": "Les prix Eversports en direct priment. Tant que les prix par cours ne sont pas disponibles, Copilot peut envoyer le lien de la page Prices — nous n’inventons jamais de montants en euros.",
      "ctaReviewLinks": "Vérifier les liens de section dans Studio Data",
      "ctaReviewClasses": "Vérifier cours et prix dans Studio Data",
      "titleError": "Échec de la synchronisation",
      "hintError": "Nous n'avons pas pu importer les données de votre studio pour le moment.",
      "errorBody": "Une erreur s'est produite lors de l'import de vos données. Vous pouvez réessayer maintenant ou terminer la configuration et réessayer plus tard depuis les Paramètres.",
      "retry": "Réessayer la synchronisation",
      "back": "Retour"
    }
  },
  "management": {
    "title": "Gestion pilote",
    "subtitle": "Inviter et contrôler l'onboarding des clients pilotes.",
    "signOut": "Se déconnecter",
    "login": {
      "title": "Accès management",
      "subtitle": "Connectez-vous avec un compte admin plateforme.",
      "emailLabel": "E-mail",
      "emailPlaceholder": "admin@oktogo.ai",
      "passwordLabel": "Mot de passe",
      "passwordPlaceholder": "Saisissez le mot de passe",
      "signIn": "Se connecter",
      "signingIn": "Connexion..."
    },
    "accept": {
      "title": "Accepter l'invitation pilote",
      "subtitle": "Créez votre mot de passe sécurisé pour commencer l'onboarding.",
      "email": "E-mail",
      "studio": "Studio",
      "expiresAt": "Expire le",
      "password": "Mot de passe",
      "passwordPlaceholder": "Créez un mot de passe",
      "terms": "J'accepte les conditions d'onboarding pilote",
      "submit": "Accepter l'invitation",
      "accepting": "Acceptation de l'invitation..."
    },
    "createInvite": {
      "title": "Créer une invitation pilote",
      "email": "E-mail du propriétaire",
      "fullName": "Nom complet (optionnel)",
      "studioName": "Nom du studio",
      "planId": "ID du plan",
      "submit": "Créer et envoyer l'invitation",
      "creating": "Création de l'invitation..."
    },
    "invites": {
      "title": "Invitations pilotes",
      "loading": "Chargement des invitations...",
      "empty": "Aucune invitation pour ce filtre.",
      "filterAria": "Filtrer les invitations par statut",
      "filterAll": "Tous les statuts",
      "columns": {
        "email": "E-mail",
        "studio": "Studio",
        "status": "Statut",
        "expiresAt": "Expire le",
        "actions": "Actions"
      },
      "actions": {
        "resend": "Renvoyer",
        "revoke": "Révoquer"
      }
    },
    "status": {
      "pending": "En attente",
      "sent": "Envoyée",
      "accepted": "Acceptée",
      "expired": "Expirée",
      "revoked": "Révoquée"
    },
    "vertical": {
      "fitness": "Fitness",
      "shortTermRental": "Location courte durée"
    },
    "messages": {
      "inviteCreated": "Invitation pilote créée ({{id}}).",
      "inviteActionSuccess": "Invitation mise à jour.",
      "inviteAccepted": "Invitation acceptée. Votre compte est maintenant actif."
    },
    "errors": {
      "login": "Connexion impossible.",
      "platformAdminRequired": "Un accès admin plateforme est requis.",
      "loadInvites": "Impossible de charger les invitations.",
      "createInvite": "Impossible de créer l'invitation.",
      "inviteAction": "Impossible de mettre à jour l'invitation.",
      "invalidInviteToken": "Le jeton d'invitation est manquant.",
      "loadInviteToken": "Impossible de valider ce jeton d'invitation.",
      "acceptInvite": "Impossible d'accepter l'invitation."
    }
  },
  "compliance": {
    "aiDisclosure": {
      "auto": {
        "plain": "Bonjour ! Cet échange se fait avec l'assistant IA de ce studio. Je peux aider pour le planning, les réservations et les questions rapides - un membre de l'équipe peut intervenir à tout moment.",
        "named": "Bonjour {{channelFirstName}}. Cet échange se fait avec l'assistant IA de ce studio. Je peux aider pour le planning, les réservations et les questions rapides - un membre de l'équipe peut intervenir à tout moment."
      },
      "manual": {
        "plain": "Bonjour ! Cet échange se fait avec l'assistant IA de ce studio. J'ai préparé cette réponse et un membre de l'équipe l'a vérifiée avant l'envoi - une personne reste joignable à tout moment.",
        "named": "Bonjour {{channelFirstName}}. Cet échange se fait avec l'assistant IA de ce studio. J'ai préparé cette réponse et un membre de l'équipe l'a vérifiée avant l'envoi - une personne reste joignable à tout moment."
      }
    }
  }
}
